<template>
    <div v-if="showLoader">
        <Loader></Loader>
    </div>
    <div v-else>
        <div v-if="isDraftContractSigned || isInApprovalMode">
            <div v-if="isDraftContractSigned">
                <h1>{{ $t('digital.signed.headline') }}</h1>
                <p>{{ $t('digital.signed.label') }}</p>
            </div>
        </div>
        <div v-else class="inner contract-wizard">
            <div class="overview-nav" :class="openOverviewNav ? 'closed': 'open'">
                <div class="toggle-bar" @click="toggleOverviewNav">
                    <div class="icon">
                        <SvgIcon icon="toggle"/>
                    </div>
                </div>
                <div class="heading">
                    <h1>{{ $t('contracts.create.headline') }}</h1>
                    <p>
                        <!-- {{getSingleProperty.address}}  -->
                        {{ addressLine1 }}
                        <br/>
                        {{ getSingleProperty.zip_code }} {{ getSingleProperty.city }}

                    </p>
                </div>
                <div class="create-bottom">
                    <div class="content">
                        <div class="double-buttons">
                            <button :disabled="showPrevStep == false" v-on:click="tabStep(-1)" class="transparent">
                                <SvgIcon icon="button-prev"/>
                                {{ $t('digital.previousstep') }}
                            </button>
                            <button :disabled="showNextStep == false" v-on:click="tabStep(1)" class="transparent">
                                {{ $t('digital.tabs.nextstep') }}
                                <SvgIcon icon="button-next"/>
                            </button>
                        </div>

                        <div class="button-container">
                            <button @click.prevent="createPdf" :disabled="generatingPdf" class="transparent">
                                <span v-if="generatingPdf">{{ $t('digital.tabs.review.generatingpdf') }} ...</span>
                                <span v-else>{{ $t('digital.tabs.review.preview') }}</span>
                            </button>

                            <button class="transparent" :disabled="saveDraftButtonDisabled || readOnlyFields"
                                    @click.prevent="save()">
                                <span v-if="saveDraftButtonDisabled">{{ $t('digital.saving') }} ...</span>
                                <span v-if="!saveDraftButtonDisabled">{{ $t('digital.savedraft') }}</span>
                            </button>
                            <!--  -->
                        </div>
                    </div>
                </div>
            </div>

            <ContractPreview ref="pdfViewer" :url="pdfPreviewUrl" v-show="showPdfViewver"/>

            <div class="screening-upload" :class="openOverviewNav ? 'closed': 'open'">


                <div class="nav-top only-mobile" @click="toggleTopNav"
                     :class="tabTitle === 'Særlige vilkår §11' ? 'half': 'full'">
                    <div class="content" :class="openTopNav ? 'open': 'closed'">
                        <div>
                            <p>Step {{ currentStep }} af {{ totalSteps }}</p>
                            <p class="step-title">{{ tabTitle }}</p>
                        </div>
                        <SvgIcon icon="select-arrow"/>
                    </div>
                </div>
                <div class="nav-top-overlay" @click="toggleTopNav" :class="openTopNav ? 'open': 'closed'"></div>
                <!-- @clicked="markBulletsAsCompleted" -->
                <tabs ref="tabList" id="contract-tabs" @clicked="tabClicked" @changed="markBulletsAsCompleted"
                      :class=" openTopNav ? 'navopen': 'navclosed'">
                    <!-- GENERAL TAB START -->
                    <tab :name="$t('digital.tabs.general.tabname')" id="tab-general">

                        <div class="tab-top">
                            <h2>{{ $t('digital.tabs.general.headline') }}</h2>
                            <p>{{ $t('digital.tabs.general.text') }}: <br/>
                                {{ getSingleProperty.address }}.</p>
                        </div>

                        <div class="seperator"></div>

                        <div class="wizard-component data-input">
                            <div class="inputs">
                                <div class="input-container">
                                    <p class="subject">{{ $t('digital.tabs.general.rental-number.label') }}</p>
                                    <div class="input-inner">
                                        <input type="text" v-model="contractData.rentalNo">
                                    </div>
                                    <span
                                        class="small-text">{{
                                            $t('digital.tabs.general.rental-number-not-required')
                                        }}</span>
                                </div>

                                <div class="seperator"></div>

                                <div class="input-container">
                                    <p class="subject">{{ $t('digital.tabs.general.rent.label') }}</p>
                                    <div class="input-inner pricing-input">
                                        <vue-numeric
                                            :read-only="readOnlyFields"
                                            :currency="inputCurrency"
                                            :separator="inputSeparator"
                                            v-on:change="updateAutoCalculations"
                                            :precision="0"
                                            v-model="contractData.rent"
                                        />
                                        <!-- <input :readonly="readOnlyFields" type="number" v-on:change="updateAutoCalculations" v-model="contractData.rent"> -->
                                        <span class="label-after">Kr.</span>
                                    </div>
                                    <span class="small-text">{{ $t('digital.tabs.general.rent.comment') }}</span>
                                </div>

                                <div class="checkbox-list" v-if="getSubscriptionId > 1">
                                    <label class="custom-checkbox">
                                        <input
                                            :readonly="readOnlyFields"
                                            type="checkbox"
                                            v-model="contractData.ignore_first_rent_on_move_in"
                                            @change="pushSpecialConditions"
                                            :true-value="true"
                                            :false-value="false"
                                        >
                                        <span class="checkbox">
                                        <SvgIcon icon="checkmark-input"/>
                                    </span>
                                        <p>{{ $t('digital.tabs.general.ignore_first_rent_on_move_in') }}</p>
                                    </label>
                                </div>

                                <div class="seperator"></div>

                                <div class="wizard-component">
                                    <p class="subject">{{ $t('digital.tabs.payments.paydate.label') }}</p>
                                    <label for="monthlyPaymentRate" class="custom-radio">
                                        <input :readonly="readOnlyFields" v-on:change="updateAutoCalculations"
                                               id="monthlyPaymentRate" type="radio" value="1"
                                               v-model="contractData.paymentMonthlyOrThirdMonth"/>
                                        <span class="radio-circle"></span>
                                        <p>{{ $t('digital.tabs.payments.paymonthly') }}</p>
                                    </label>
                                    <label for="every3MonthsPaymentRate" class="custom-radio">
                                        <input :readonly="readOnlyFields" v-on:change="updateAutoCalculations"
                                               id="every3MonthsPaymentRate" type="radio" value="2"
                                               v-model="contractData.paymentMonthlyOrThirdMonth"/>
                                        <span class="radio-circle"></span>
                                        <p>{{ $t('digital.tabs.payments.payeverythirdmonth') }}</p>
                                    </label>
                                </div>

                                <div class="seperator"></div>

                                <div class="wizard-component input-container">
                                    <p class="subject">{{ $t('digital.tabs.general.due-date') }}</p>
                                    <div class="input-inner">
                                        <input
                                            type="text"
                                            v-model="contractData.monthlyPayDate"
                                            v-on:keyup="validateMonthlyPayDate()"
                                            v-on:blur="validateMonthlyPayDate()"/>
                                    </div>
                                    <span class="small-text">{{ $t('digital.tabs.general.due-date-comment') }}</span>
                                </div>

                                <div class="seperator"></div>

                                <div class="input-container wizard-component">
                                    <p class="subject">{{ $t('digital.tabs.general.occupancy.label') }}</p>
                                    <div class="input-inner date-input">
                                        <form>
                                            <DateTimeInput
                                                id="occupancyDate"
                                                :readonly="readOnlyFields"
                                                :time="false"
                                                :value="contractData.occupancyDate"
                                                autofill="off" autocomplete="false"
                                            />
                                        </form>
                                        <!-- <datetime
                                            :phrases="{ok: 'Vælg', cancel: 'Annuller'}"
                                            :format="{ year: 'numeric', month: 'long', day: 'numeric' }"
                                            :placeholder="$t('inputs.date.placeholder')"
                                            format="dd/MM/yyyy" type="date"
                                            :readonly="readOnlyFields"
                                            v-on:change="updateTaxationDate"
                                            v-model="contractData.occupancyDate"
                                            input-id="occupancyDateSelector"
                                        ></datetime> -->
                                        <span class="label-after">
                                            <SvgIcon icon="calendar"/>
                                        </span>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="wizard-component checkboxes">
                            <div class="checkbox-list">
                                <label class="custom-checkbox">
                                    <input
                                        :readonly="readOnlyFields"
                                        type="checkbox"
                                        v-model="contractData.limitedRenting"
                                        @change="pushSpecialConditions"
                                    >
                                    <span class="checkbox">
                                        <SvgIcon icon="checkmark-input"/>
                                    </span>
                                    <p>{{ $t('digital.tabs.general.limited.label') }}</p>
                                </label>
                                <div v-if="contractData.limitedRenting" class="checkbox-choices choices-dropdown">
                                    <div class="arrow-up">
                                        <SvgIcon icon="arrow-up"/>
                                    </div>
                                    <div class="content">
                                        <p class="subject">{{ $t('digital.tabs.general.limited.date') }}</p>
                                        <div class="date-input input-inner">
                                            <DateTimeInput
                                                id="rentalExpires"
                                                :readonly="readOnlyFields"
                                                :value="contractData.rentalExpires"
                                                :time="false"
                                                autofill="off"
                                                autocomplete="false"
                                                @change="pushSpecialConditions"
                                            />
                                            <span class="label-after">
                                                <SvgIcon icon="calendar"/>
                                            </span>
                                        </div>
                                        <template v-if="!isRentalTerminationValid">
                                            {{ $t('digital.tabs.general.termination-date-invalid') }}
                                        </template>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="seperator"></div>

                        <div class="wizard-component radio-buttons with-checkboxes">
                            <p class="subject">{{ $t('digital.tabs.about.type.label') }}</p>
                            <div>
                                <label v-for="rentalType in contractData.rentalTypes" class="custom-radio">
                                    <input :readonly="readOnlyFields" :value="rentalType.id" type="radio"
                                           v-model="contractData.rentalType">
                                    <span class="radio-circle"></span>
                                    <p>{{ $t(rentalType.name) }}</p>
                                </label>
                                <div v-if="contractData.rentalType == 7" class="choices-dropdown">
                                    <div class="arrow-up">
                                        <SvgIcon icon="arrow-up"/>
                                    </div>
                                    <div class="content">
                                        <div class="input-container">
                                            <p class="subject">{{ $t('digital.tabs.other-rental-type.label') }}</p>
                                            <div class="input-inner">
                                                <form><input :readonly="readOnlyFields" type="text"
                                                             v-model="contractData.otherRentalType" autofill="off"
                                                             autocomplete="false"/></form>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="seperator"></div>

                        <div class="wizard-component checkboxes">
                            <div class="checkbox-list">
                                <label class="custom-checkbox">
                                    <input :readonly="readOnlyFields" type="checkbox" v-model="contractData.sublease">
                                    <span class="checkbox">
                                        <SvgIcon icon="checkmark-input"/>
                                    </span>
                                    <p>{{ $t('digital.tabs.about.type.sublease') }}</p>
                                </label>
                                <span class="small-text">{{ $t('digital.tabs.about.type.sublease-text') }}</span>
                                <!-- <label class="custom-checkbox">
                                    <input :readonly="readOnlyFields" type="checkbox" v-model="contractData.representation">
                                    <span class="checkbox">
                                        <SvgIcon icon="checkmark-input" />
                                    </span>
                                    <p>{{$t('digital.tabs.about.type.presentation-label')}}</p>
                                </label>
                                <span class="small-text">{{$t('digital.tabs.about.type.presentation-text')}}</span> -->
                            </div>
                        </div>

                        <div class="seperator"></div>

                        <div class="wizard-component range-input">
                            <p class="subject">{{ $t('digital.tabs.about.rooms.label') }}</p>
                            <range-input :readonly="readOnlyFields" v-model="contractData.numberOfRooms"></range-input>
                        </div>

                        <div class="seperator"></div>

                        <div class="wizard-component data-input">
                            <div class="inputs">
                                <div class="input-container">
                                    <p class="subject">{{ $t('digital.tabs.about.size.label') }}</p>
                                    <div class="input-inner area-input">

                                        <vue-numeric
                                            :read-only="readOnlyFields"
                                            :currency="inputCurrency"
                                            :separator="inputSeparator"
                                            v-on:change="updateAutoCalculations"
                                            :precision="0"
                                            v-model="contractData.area"/>

                                        <!-- <input :readonly="readOnlyFields" type="number" name="" v-model="contractData.area"> -->
                                        <span class="label-after">M<sup>2</sup></span>
                                    </div>
                                    <span class="small-text">{{ $t('digital.tabs.about.size.comment') }}</span>
                                </div>
                                <div class="input-container">
                                    <p class="subject">{{ $t('digital.tabs.about.office.label') }}</p>
                                    <div class="input-inner area-input">

                                        <vue-numeric
                                            :read-only="readOnlyFields"
                                            :currency="inputCurrency"
                                            :separator="inputSeparator"
                                            v-on:change="updateAutoCalculations"
                                            :precision="0"
                                            v-model="contractData.areaForBusiness"/>

                                        <!-- <input :readonly="readOnlyFields" type="number" name="" v-model="contractData.areaForBusiness"> -->
                                        <span class="label-after">M<sup>2</sup></span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="seperator"></div>

                        <button v-if="showNextStep" v-on:click="tabStep(1)" class="purple next-btn">
                            {{ $t('digital.tabs.nextstep') }}
                        </button>

                    </tab>
                    <!-- GENERAL TAB END -->

                    <!-- SUPPLY TAB START -->
                    <tab :name="$t('digital.tabs.supply.tabname')" id="tab-supply">
                        <div class="tab-top">
                            <h2>{{ $t('digital.tabs.supply.headline') }}</h2>
                            <p>{{ $t('digital.tabs.supply.text') }}</p>
                        </div>

                        <div class="seperator"></div>

                        <!-- Electricity supply -->
                        <div style="display: none;">
                            {{ electricityAccountingValue }}
                            {{ electricityRadiosValue }}
                        </div>
                        <div class="wizard-component radio-buttons with-checkboxes">
                            <p class="subject">{{ $t('digital.tabs.supply.electricity') }}</p>
                            <label for="accounting_onaccount_electricity" class="custom-radio">
                                <input v-on:change="changeSupplyAccountingMode('electricity')"
                                       :readonly="readOnlyFields"
                                       id="accounting_onaccount_electricity" type="radio"
                                       value="onaccount"
                                       v-model="contractData.electricityAccountingMode"
                                       name="electricity"
                                       v-on:click="setOnAccountValue" />
                                <span class="radio-circle"></span>
                                <p>{{ $t('digital.tabs.supply.onaccount-electricity') }}</p>
                            </label>
                            <div v-if="contractData.electricityAccountingMode == 'onaccount'" class="choices-dropdown">
                                <div class="arrow-up">
                                    <SvgIcon icon="arrow-up"/>
                                </div>
                                <div class="content">
                                    <p class="subject">{{
                                            $t('digital.tabs.supply.electricityaccountedfrom')
                                        }}</p>
                                    <div class="date-input input-inner">

                                        <DateTimeInput
                                            id="electricityAccountedFrom"
                                            :readonly="readOnlyFields"
                                            :value="contractData.electricityAccountedFrom"
                                            :time="false"/>

                                        <span class="label-after">
                                            <SvgIcon icon="calendar"/>
                                        </span>
                                    </div>
                                    <div class="checkbox-list">
                                        <label class="custom-checkbox">
                                            <input :readonly="readOnlyFields" type="checkbox"
                                                   v-model="contractData.electricityIndividualMeasurements">
                                            <span class="checkbox">
                                                <SvgIcon icon="checkmark-input"/>
                                            </span>
                                            <p>{{
                                                    $t('digital.tabs.supply.electricityindividual-dispenses')
                                                }}</p>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <label for="accounting_included_in_rent_electricity" class="custom-radio">
                                <input v-on:change="changeSupplyAccountingMode('electricity')"
                                       :readonly="readOnlyFields"
                                       id="accounting_included_in_rent_electricity" type="radio"
                                       value="included_in_rent"
                                       v-model="contractData.electricityAccountingMode"
                                       name="electricity"
                                       v-on:click="setOnAccountValue"
                                        />
                                <span class="radio-circle"></span>
                                <p>{{ $t('digital.tabs.supply.included_in_rent-electricity') }}</p>
                            </label>
                            <label for="accounting_third_party_electricity" class="custom-radio">
                                <input
                                       :readonly="readOnlyFields"
                                       id="accounting_third_party_electricity" type="radio"
                                       value="third"
                                       v-model="electricityRadios"
                                       name="electricity"
                                       v-on:click="setModeValue"
                                       />
                                <span class="radio-circle"></span>
                                <p>{{ $t('digital.tabs.supply.third_party-electricity') }}</p>
                            </label>
                            <div
                                v-if="contractData.electricityAccountingMode == 'third_party_simplex'
                                    || contractData.electricityAccountingMode == 'third_party'"
                                class="choices-dropdown with-radios">
                                <div class="arrow-up">
                                    <SvgIcon icon="arrow-up"/>
                                </div>
                                <div class="content">
                                    <div class="section" :class="{'opacity-5' : !electricitySimplexAvailable}">
                                        <label for="simplex" class="custom-radio">
                                            <input :disabled="!electricitySimplexAvailable" v-on:change="changeSupplyAccountingMode('electricity')" type="radio" name="electricity_third" id="simplex" value="third_party_simplex" v-model="contractData.electricityAccountingMode">
                                            <span class="radio-circle"></span>
                                            <div>
                                                <p class="title">{{ $t('supply.power.automatic-headline') }}</p>
                                                <p>{{ $t('supply.power.automatic-description') }} </p><a @click="supplyDetails">{{ $t('supply.power.automatic-link') }}</a>
                                            </div>
                                        </label>
                                    </div>
                                    <div class="section">
                                        <label for="third" class="custom-radio">
                                            <input v-on:change="changeSupplyAccountingMode('electricity')" type="radio" name="electricity_third" id="third" value="third_party" v-model="contractData.electricityAccountingMode">
                                            <span class="radio-circle"></span>
                                            <div>
                                                <p class="title">{{ $t('supply.power.none-headline') }}</p>
                                                <p>{{ $t('supply.power.none-description') }}</p>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <modal v-if="showSupplyDetails" id="power-supply-info" v-on:close="showSupplyDetails = false">
                                <div class="modal-container with-table medium-modal" slot="modal-container">
                                    <div class="close" v-on:click="showSupplyDetails = false">
                                        <SvgIcon icon="close"/>
                                    </div>
                                    <h2>{{$t('supply.power.modal-headline')}}</h2>
                                    <p class="text">{{ $t('supply.power.modal-text1') }}</p>
                                    <div>
                                        <p class="text">{{ $t('supply.power.modal-text2') }} <a target="_blank" href="https://nrgi.dk/privat/priser/vores-priser-og-produkter/bevar-mig-el/">{{ $t('supply.power.modal-link') }}</a></p>
                                    </div>
                                </div>
                            </modal>
                        </div>
                        <div class="seperator"></div>


                        <!-- GENERALIZED SUPPLY -->
                        <div v-for="(supplyElement,name) in supplyElements">
                            {{ supplyElements.id }}
                            <div class="wizard-component radio-buttons with-checkboxes">
                                <p class="subject">{{ $t('digital.tabs.supply.' + name) }}</p>

                                <template v-for="(accountingModeData, accountingMode) in accountingModes">
                                    <template
                                        v-if="accountingMode != 'third_party' || (accountingMode == 'third_party' && supplyElement.enableThirdPartyOption)">
                                        <label :for="'accounting_'+accountingMode+'_'+name" class="custom-radio">
                                            <input v-on:change="changeSupplyAccountingMode(name)"
                                                   :readonly="readOnlyFields"
                                                   :id="'accounting_'+accountingMode+'_'+name" type="radio"
                                                   :value="accountingMode"
                                                   v-model="contractData[name+'AccountingMode']"/>
                                            <span class="radio-circle"></span>
                                            <p>{{ $t('digital.tabs.supply.' + accountingMode + '-' + name) }}</p>
                                        </label>

                                        <template v-if="displaySupplyGroup(name, accountingMode)">
                                            <div v-if="contractData[name+'AccountingMode'] == accountingMode"
                                                 class="choices-dropdown">
                                                <div class="arrow-up">
                                                    <SvgIcon icon="arrow-up"/>
                                                </div>
                                                <div class="content">
                                                    <div v-if="contractData[name+'AccountingMode'] == 'onaccount'">
                                                        <p class="subject">{{
                                                                $t('digital.tabs.supply.' + name + 'accountedfrom')
                                                            }}</p>
                                                        <div class="date-input input-inner">

                                                            <DateTimeInput
                                                                :id="'Supply_'+name+'AccountedFrom'"
                                                                :readonly="readOnlyFields"
                                                                :value="contractData[name+'AccountedFrom']"
                                                                :time="false"/>

                                                            <!-- <datetime
                                                                :phrases="{ok: 'Vælg', cancel: 'Annuller'}"
                                                                :format="{ year: 'numeric', month: 'long', day: 'numeric' }"
                                                                :placeholder="$t('inputs.date.placeholder')"
                                                                format="dd/MM/yyyy" type="date"
                                                                :readonly="readOnlyFields"
                                                                v-model="contractData[name+'AccountedFrom']"
                                                                :input-id="name+'DateTimeAccountFrom'"
                                                            ></datetime> -->
                                                            <span class="label-after">
                                                                <SvgIcon icon="calendar"/>
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div
                                                        v-if="typeof supplyElement.sources == 'undefined' && contractData[name+'AccountingMode'] == 'onaccount'"
                                                        class="checkbox-list">

                                                        <label class="custom-checkbox">
                                                            <input :readonly="readOnlyFields" type="checkbox"
                                                                   v-model="contractData[name+'IndividualMeasurements']">
                                                            <span class="checkbox">
                                                                <SvgIcon icon="checkmark-input"/>
                                                            </span>
                                                            <p>{{
                                                                    $t('digital.tabs.supply.' + name + 'individual-dispenses')
                                                                }}</p>
                                                        </label>

                                                    </div>
                                                    <br>
                                                    <div class="checkbox-list"
                                                         v-if="supplyElement.sources != undefined">
                                                        <p class="subject">{{ $t('digital.tabs.supply.heated-by') }}</p>
                                                        <template v-for="source in supplyElement.sources">
                                                            <label
                                                                v-if="source.accountingMode.indexOf(contractData[name+'AccountingMode']) >= 0"
                                                                :for="'source'+source.id" class="custom-checkbox">
                                                                <input :readonly="readOnlyFields" :value="source.id"
                                                                       :id="'source'+source.id" type="checkbox"
                                                                       v-model="contractData[name+'Source'][source.id]">
                                                                <span class="checkbox">
                                                                    <SvgIcon icon="checkmark-input"/>
                                                                </span>
                                                                <p>{{ $t(source.label) }}</p>
                                                            </label>
                                                        </template>
                                                        <label class="custom-checkbox"
                                                               v-if="supplyElement.customizable != undefined">
                                                            <input :readonly="readOnlyFields" :id="'customizable-'+name"
                                                                   type="checkbox" v-model="heatingShowOther"/>
                                                            <span class="checkbox">
                                                                <SvgIcon icon="checkmark-input"/>
                                                            </span>
                                                            <p>{{ $t(supplyElement.customizable.label) }}</p>
                                                        </label>
                                                        <div v-if="heatingShowOther">
                                                            <input
                                                                :placeholder="$t('digital.tabs.supply.heating-other-placeholder')"
                                                                v-model="contractData[supplyElement.customizable.model]"/>
                                                        </div>
                                                        <br>
                                                    </div>

                                                </div>
                                            </div>
                                        </template>


                                    </template>
                                </template>

                                <label v-if="supplyElement.enableNoneOption" class="custom-radio">
                                    <input
                                        v-on:change="changeSupplyAccountingMode(name)"
                                        :readonly="readOnlyFields"
                                        :id="'accounting_'+'none'+'_'+name"
                                        type="radio"
                                        :value="'none'"
                                        v-model="contractData[name+'AccountingMode']"
                                    />
                                    <span class="radio-circle"></span>
                                    <p>{{ $t('digital.tabs.supply.' + 'no' + '-' + name) }}</p>
                                </label>
                            </div>
                            <div class="seperator"></div>
                        </div>


                        <div class="wizard-component checkboxes">
                            <p class="subject">{{ $t('digital.tabs.access.residentPresentation-label') }}</p>
                            <div class="checkbox-list">
                                <label class="custom-checkbox">
                                    <input :readonly="readOnlyFields" type="checkbox"
                                           v-model="contractData.representation">
                                    <span class="checkbox">
                                        <SvgIcon icon="checkmark-input"/>
                                    </span>
                                    <p>{{ $t('digital.tabs.access.residentPresentation') }}</p>
                                </label>
                            </div>
                        </div>

                        <div class="seperator"></div>

                        <div class="wizard-component checkboxes">
                            <p class="subject">{{ $t('digital.tabs.access.electronics') }}</p>
                            <div class="checkbox-list">
                                <label class="custom-checkbox">
                                    <input type="checkbox" name="" v-model="contractData.sharedSignalSupply">
                                    <span class="checkbox">
                                        <SvgIcon icon="checkmark-input"/>
                                    </span>
                                    <p>{{ $t('digital.tabs.access.signalsupply.included') }}</p>
                                </label>
                                <div v-if="contractData.sharedSignalSupply" class="choices-dropdown">
                                    <div class="arrow-up">
                                        <SvgIcon icon="arrow-up"/>
                                    </div>
                                    <div class="content">
                                        <p class="subject">{{ $t('digital.tabs.access.signalsupply.label') }}</p>
                                        <label class="custom-radio">
                                            <input
                                                id="1"
                                                type="radio"
                                                value="onaccount"
                                                @change="pushSpecialConditions"
                                                v-model="contractData.signalSupplyBy"
                                            />
                                            <span class="radio-circle"></span>
                                            <p>{{ $t('digital.tabs.supply.aconto-landlord') }}</p>
                                        </label>
                                        <label class="custom-radio">
                                            <input
                                                id="2"
                                                type="radio"
                                                value="union"
                                                @change="pushSpecialConditions"
                                                v-model="contractData.signalSupplyBy"
                                            />
                                            <span class="radio-circle"></span>
                                            <p>{{ $t('digital.tabs.supply.by-union') }}</p>
                                        </label>
                                    </div>
                                </div>

                                <label class="custom-checkbox">
                                    <input
                                        :readonly="readOnlyFields"
                                        type="checkbox"
                                        v-model="contractData.landlordSuppliesInternetAccess"
                                        @change="pushSpecialConditions"
                                    >
                                    <span class="checkbox">
                                        <SvgIcon icon="checkmark-input"/>
                                    </span>
                                    <p>{{ $t('digital.tabs.access.landlordsuppliesinternetaccess') }}</p>
                                </label>

                            </div>
                        </div>

                        <div class="seperator"></div>

                        <button v-if="showNextStep" v-on:click="tabStep(1)" class="purple next-btn">
                            {{ $t('digital.tabs.nextstep') }}
                        </button>

                    </tab>
                    <!-- SUPPLY TAB END -->

                    <!-- MONTHLY PAYMENTS TAB START -->
                    <tab :name="$t('digital.tab.monthly-payments.tabname')" id="tab-monthly-payments">
                        <div class="tab-top">
                            <h2>{{ $t('digital.tab.monthly-payments.headline') }}</h2>
                            <p>{{ $t('digital.tab.monthly-payments.text') }}</p>
                        </div>

                        <div class="seperator"></div>

                        <div class="wizard-component data-inputs">
                            <div class="inputs">
                                <div v-if="contractData['heatingAccountingMode'] == 'onaccount'"
                                     class="input-container">
                                    <p class="subject">{{ $t('digital.tabs.payments.onaccount.heating') }}</p>
                                    <div class="input-inner area-input">
                                        <vue-numeric
                                            :read-only="readOnlyFields"
                                            :currency="inputCurrency"
                                            :separator="inputSeparator"
                                            :precision="0"
                                            v-model="contractData.onAccount.heating"
                                        />
                                        <span class="label-after">Kr.</span>
                                    </div>
                                </div>

                                <div v-if="contractData['waterAccountingMode'] == 'onaccount'" class="input-container">
                                    <p class="subject">{{ $t('digital.tabs.payments.onaccount.water') }}</p>
                                    <div class="input-inner area-input">
                                        <vue-numeric
                                            :read-only="readOnlyFields"
                                            :currency="inputCurrency"
                                            :separator="inputSeparator"
                                            :precision="0"
                                            v-model="contractData.onAccount.water"
                                        />
                                        <span class="label-after">Kr.</span>
                                    </div>
                                </div>
                                <div v-if="contractData['electricityAccountingMode'] == 'onaccount'"
                                     class="input-container">
                                    <p class="subject">{{ $t('digital.tabs.payments.onaccount.electricity') }}</p>
                                    <div class="input-inner area-input">
                                        <vue-numeric
                                            :read-only="readOnlyFields"
                                            :currency="inputCurrency"
                                            :separator="inputSeparator"
                                            :precision="0"
                                            v-model="contractData.onAccount.electricity"
                                        />
                                        <span class="label-after">Kr.</span>
                                    </div>
                                </div>
                                <div v-if="contractData['coolingAccountingMode'] == 'onaccount'"
                                     class="input-container">
                                    <p class="subject">{{ $t('digital.tabs.payments.onaccount.cooling') }}</p>
                                    <div class="input-inner area-input">
                                        <vue-numeric
                                            :read-only="readOnlyFields"
                                            :currency="inputCurrency"
                                            :separator="inputSeparator"
                                            :precision="0"
                                            v-model="contractData.onAccount.cooling"
                                        />
                                        <span class="label-after">Kr.</span>
                                    </div>
                                </div>
                                <div v-if="contractData.sharedSignalSupply" class="input-container">
                                    <p class="subject">{{ $t('digital.tabs.payments.onaccount.antenna') }}</p>
                                    <div class="input-inner area-input">
                                        <vue-numeric
                                            :read-only="readOnlyFields"
                                            :currency="inputCurrency"
                                            :separator="inputSeparator"
                                            :precision="0"
                                            v-model="contractData.onAccount.antenna"
                                        />
                                        <span class="label-after">Kr.</span>
                                    </div>
                                </div>
                                <div v-if="contractData.landlordSuppliesInternetAccess" class="input-container">
                                    <p class="subject">{{ $t('digital.tabs.payments.onaccount.internet') }}</p>
                                    <div class="input-inner area-input">
                                        <vue-numeric
                                            :read-only="readOnlyFields"
                                            :currency="inputCurrency"
                                            :separator="inputSeparator"
                                            :precision="0"
                                            v-model="contractData.onAccount.internet"
                                        />
                                        <span class="label-after">Kr.</span>
                                    </div>
                                </div>
                                <div v-if="contractData.representation" class="input-container">
                                    <p class="subject">{{ $t('digital.tabs.payments.onaccount.representation') }}</p>
                                    <div class="input-inner area-input">
                                        <vue-numeric
                                            :read-only="readOnlyFields"
                                            :currency="inputCurrency"
                                            :separator="inputSeparator"
                                            :precision="0"
                                            v-model="contractData.onAccount.representation"
                                        />
                                        <span class="label-after">Kr.</span>
                                    </div>
                                </div>
                                <div class="add-more">
                                    <p class="subject">{{ $t('onaccount.add-more.label') }}</p>
                                    <div v-for="(extraOnAccount,idx) in contractData.extraOnAccount" class="input-new">
                                        <div class="input-container double">
                                            <div class="input-inner">
                                                <input :readonly="readOnlyFields" type="text"
                                                       v-model="extraOnAccount.name"
                                                       :placeholder="$t('onaccount.add-more.placeholder')">
                                            </div>
                                        </div>
                                        <div class="input-container double">
                                            <div class="input-inner area-input">
                                                <vue-numeric
                                                    :read-only="readOnlyFields"
                                                    :currency="inputCurrency"
                                                    :separator="inputSeparator"
                                                    :precision="0"
                                                    v-model="extraOnAccount.value"
                                                />
                                                <span class="label-after">Kr.</span>
                                            </div>
                                        </div>
                                        <div v-on:click="deleteExtraOnAccount(idx)" class="delete">
                                            <SvgIcon icon="delete"/>
                                        </div>
                                    </div>

                                    <button class="green" v-if="contractData.extraOnAccount.length < 2"
                                            v-on:click="addOnAccount">
                                        <SvgIcon icon="plus-circle"/>
                                        {{ $t('button.onaccount.add-more') }}
                                    </button>
                                </div>
                            </div>

                            <!-- <div class="inputs">
                                <div class="input-container">
                                    <p class="subject">{{ $t('digital.tabs.payment.total-cost-excluding') }}</p>
                                    <div class="input-inner area-input">
                                        <input :readonly="readOnlyFields" type="text">
                                        <span class="label-after">Kr.</span>
                                    </div>
                                </div>
                                <div class="input-container">
                                    <p class="subject">{{ $t('digital.tabs.payment.total-cost-including') }}</p>
                                    <div class="input-inner area-input">
                                        <input :readonly="readOnlyFields" type="text" value="10000">
                                        <span class="label-after">Kr.</span>
                                    </div>
                                </div>
                            </div> -->

                            <div class="review">
                                <div class="box preview-box">
                                    <p class="subject">{{ $t('digital.tabs.payments.onaccounttaxationdate.label') }}</p>
                                    <div class="content">

                                        <div class="input-inner date-input">
                                            <form>
                                                <DateTimeInput
                                                    id="onAccountTaxationDate"
                                                    :readonly="readOnlyFields"
                                                    :time="false"
                                                    :value="contractData.onAccountTaxationDate"
                                                    autofill="off" autocomplete="false"/>
                                            </form>
                                            <!-- <datetime
                                                :phrases="{ok: 'Vælg', cancel: 'Annuller'}"
                                                :format="{ year: 'numeric', month: 'long', day: 'numeric' }"
                                                :placeholder="$t('inputs.date.placeholder')"
                                                format="dd/MM/yyyy" type="date"
                                                v-model="contractData.onAccountTaxationDate"
                                                input-id="onaccount-taxation-date"
                                            ></datetime> -->
                                            <!-- <input v-model="contractData.onAccountTaxationDate"> -->
                                            <span class="label-after">
                                                <SvgIcon icon="calendar"/>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="seperator"></div>

                        <button v-if="showNextStep" v-on:click="tabStep(1)" class="purple next-btn">
                            {{ $t('digital.tabs.nextstep') }}
                        </button>
                    </tab>
                    <!-- MONTHLY PAYMENTS TAB END -->

                    <!-- DEPOSIT & RENT TAB START -->
                    <tab :name="$t('digital.tabs.deposit-others.tabname')" id="tab-deposit">
                        <div class="tab-top">
                            <h2>{{ $t('digital.tabs.deposit-others.headline') }}</h2>
                            <p>{{ $t('digital.tabs.deposit-others.label') }}</p>
                        </div>

                        <div class="seperator"></div>

                        <div class="wizard-component data-input select-field">
                            <p class="subject">{{ $t('digital.tabs.general.rent.deposit') }}</p>
                            <div class="select-container">
                                <select :readonly="readOnlyFields" v-model="contractData.depositMonths">
                                    <option value="">{{ $t('generic.choose.label') }}</option>
                                    <option id="deposit1" value="0">{{ $t('deposit.label.no-deposit') }}</option>
                                    <option id="deposit1" value="1">{{ $t('deposit.label.1month') }}
                                        ({{ (1 * contractData.rent) | toCurrency }} kr.)
                                    </option>
                                    <option id="deposit2" value="2">{{ $t('deposit.label.2months') }}
                                        ({{ (2 * contractData.rent) | toCurrency }} kr.)
                                    </option>
                                    <option id="deposit3" value="3">{{ $t('deposit.label.3months') }}
                                        ({{ (3 * contractData.rent) | toCurrency }} kr.)
                                    </option>
                                    <option id="deposit4" value="other">{{ $t('deposit.label.other') }}</option>
                                </select>
                                <span class="icon">
                                    <SvgIcon icon="select-arrow"/>
                                </span>
                            </div>
                            <!--
                            <template v-if="Number(contractData.depositMonths > 0)">
                                {{ (contractData.depositMonths * contractData.rent) | toCurrency }} kr.
                            </template>
                             -->
                            <div class="inputs">
                                <div v-if="contractData.depositMonths == 'other'" class="input-container">
                                    <div class="input-inner pricing-input">
                                        <vue-numeric
                                            :read-only="readOnlyFields"
                                            :currency="inputCurrency"
                                            :separator="inputSeparator"
                                            :precision="0"
                                            v-model="contractData.deposit"/>
                                        <!-- <input :readonly="readOnlyFields" type="text" name="" v-model="contractData.deposit"> -->
                                        <span class="label-after">Kr.</span>
                                    </div>
                                    <span class="small-text">{{ $t('digital.tabs.general.deposit.comment') }}</span>
                                </div>

                                <div class="input-container" v-if="String(contractData.depositMonths) !== '0'">
                                    <p class="subject">{{ $t('digital.tabs.payments.depositpaymentdate.label') }}</p>

                                    <div class="input-inner date-input">
                                        <form>
                                            <DateTimeInput
                                                :time="false"
                                                id="depositPaymentDate"
                                                :readonly="readOnlyFields"
                                                :value="contractData.depositPaymentDate"
                                                autofill="off" autocomplete="false"/>
                                        </form>
                                        <!-- <datetime
                                                :phrases="{ok: 'Vælg', cancel: 'Annuller'}"
                                                :format="{ year: 'numeric', month: 'long', day: 'numeric' }"
                                                :placeholder="$t('inputs.date.placeholder')"
                                                format="dd/MM/yyyy" type="date"
                                                v-model="contractData.depositPaymentDate"
                                                :readonly="readOnlyFields"
                                                input-id="dateTimeDepositPaymentDate"
                                        ></datetime> -->
                                        <!--  <input :readonly="readOnlyFields" type="date" name="" v-model="contractData.depositPaymentDate"> -->
                                        <span class="label-after">
                                            <SvgIcon icon="calendar"/>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="separator"></div>

                        <div class="wizard-component data-input">
                            <p class="subject">{{ $t('digital.tabs.payments.firstmonth.headline') }}</p>
                            <div class="select-container">
                                <select :readonly="readOnlyFields" v-model="contractData.prepaidMonths">
                                    <option value="">{{ $t('generic.choose.label') }}</option>
                                    <option id="prepaid" value="0">{{ $t('prepaid.label.no-prepaid-rent') }}</option>
                                    <option id="prepaid" value="1">{{ $t('deposit.label.1month') }}
                                        ({{ 1 * contractData.rent | toCurrency }} kr.)
                                    </option>
                                    <option id="prepaid" value="2">{{ $t('deposit.label.2months') }}
                                        ({{ 2 * contractData.rent | toCurrency }} kr.)
                                    </option>
                                    <option id="prepaid3" value="3">{{ $t('deposit.label.3months') }}
                                        ({{ 3 * contractData.rent | toCurrency }} kr.)
                                    </option>
                                    <option id="prepaid4" value="other">{{ $t('deposit.label.other') }}</option>
                                </select>
                                <span class="icon">
                                    <SvgIcon icon="select-arrow"/>
                                </span>
                            </div>

                            <div class="inputs">
                                <div v-if="contractData.prepaidMonths == 'other'" class="input-container">
                                    <p class="subject">{{ $t('digital.tabs.general.rent.prepaidRent') }}</p>
                                    <div class="input-inner pricing-input">
                                        <form>
                                            <vue-numeric
                                                :read-only="readOnlyFields"
                                                :currency="inputCurrency"
                                                :separator="inputSeparator"
                                                :precision="0"
                                                v-model="contractData.prepaidRent"
                                                autofill="off" autocomplete="false"/>
                                        </form>
                                        <!-- <input :readonly="readOnlyFields" type="number" name="" v-model="contractData.prepaidRent"> -->
                                        <span class="label-after">Kr.</span>
                                    </div>
                                    <span class="small-text">{{ $t('digital.tabs.general.prepaidRent.comment') }}</span>
                                </div>

                                <div class="add-more">
                                    <p class="subject">{{ $t('digital.firstmonthfees.button.label') }}</p>
                                    <div v-for="(fee, i) in contractData.firstMonthFees" :key="i" class="input-new">
                                        <div class="input-container double">
                                            <div class="input-inner area-input">
                                                <input :readonly="readOnlyFields"
                                                       :placeholder="$t('digital.tabs.payments.addfee.title.placeholder')"
                                                       v-model="fee.name"/>
                                            </div>
                                        </div>
                                        <div class="input-container double">
                                            <div class="input-inner area-input">
                                                <vue-numeric
                                                    :read-only="readOnlyFields"
                                                    :currency="inputCurrency"
                                                    :separator="inputSeparator"
                                                    :precision="0"
                                                    v-model="fee.value"/>
                                                <!-- <input :readonly="readOnlyFields" v-model="fee.value" /> -->
                                                <span class="label-after">Kr.</span>
                                            </div>
                                        </div>
                                        <div v-on:click="deleteFirstMontFee(i)" class="delete">
                                            <SvgIcon icon="delete"/>
                                        </div>
                                    </div>
                                    <button v-if="contractData.firstMonthFees.length < 2"
                                            @click.prevent="addFirstMonthFee()" class="green">
                                        <SvgIcon icon="plus-circle"/>
                                        {{ $t('digital.firstmonthfees.button.add') }}
                                    </button>
                                </div>
                                <div class="input-container">
                                    <p class="subject">{{ $t('digital.tabs.payments.firstrent.label') }}</p>
                                    <div class="input-inner date-input">
                                        <!-- <input :readonly="readOnlyFields" type="date" v-model="contractData.firstRentPaymentDate"> -->
                                        <!-- <datetime
                                            :phrases="{ok: 'Vælg', cancel: 'Annuller'}"
                                            :format="{ year: 'numeric', month: 'long', day: 'numeric' }"
                                            :placeholder="$t('inputs.date.placeholder')"
                                            format="dd/MM/yyyy" type="date"
                                            :readonly="readOnlyFields"
                                            v-model="contractData.firstRentPaymentDate"
                                            input-id="dateTimeFirstPaymentDate"
                                        ></datetime> -->
                                        <form>
                                            <DateTimeInput
                                                :time="false"
                                                id="firstRentPaymentDate"
                                                :readonly="readOnlyFields"
                                                :value="contractData.firstRentPaymentDate"
                                                autofill="off" autocomplete="false"/>
                                        </form>

                                        <span class="label-after">
                                            <SvgIcon icon="calendar"/>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="seperator"></div>

                        <div class="wizard-component review">

                            <h2>{{ $t('digital.tabs.payments.summary-headline') }}</h2>

                            <div class="box calculate">
                                <div class="content">
                                    <p class="subject">{{ $t('digital.tabs.review.paymentsbeforeoccupancydate') }}</p>
                                    <div class="info">
                                        <div>
                                            <p>{{ $t('digital.tabs.review.deposit') }}</p>
                                            <span v-if="contractData.depositMonths == '0'">
                                                {{ $t('deposit.label.no-deposit') }}
                                            </span>
                                            <span v-if="contractData.depositMonths == '1'">
                                                {{ $t('deposit.label.1month') }}
                                            </span>
                                            <span v-if="contractData.depositMonths == '2'">
                                                {{ $t('deposit.label.2months') }}
                                            </span>
                                            <span v-if="contractData.depositMonths == '3'">
                                                {{ $t('deposit.label.3months') }}
                                            </span>
                                            <span v-if="contractData.depositMonths == 'other'">
                                                {{ $t('deposit.label.other') }}
                                            </span>
                                        </div>
                                        <p>{{ subtotalDeposit | toCurrency }} DKK</p>
                                    </div>
                                    <div class="info">
                                        <div>
                                            <p>{{ $t('digital.tabs.review.prepaidrent') }}</p>
                                            <span v-if="contractData.prepaidMonths == '0'">
                                                {{ $t('prepaid.label.no-prepaid-rent') }}
                                            </span>
                                            <span v-if="contractData.prepaidMonths == '1'">
                                                {{ $t('deposit.label.1month') }}
                                            </span>
                                            <span v-if="contractData.prepaidMonths == '2'">
                                                {{ $t('deposit.label.2months') }}
                                            </span>
                                            <span v-if="contractData.prepaidMonths == '3'">
                                                {{ $t('deposit.label.3months') }}
                                            </span>
                                            <span v-if="contractData.prepaidMonths == 'other'">
                                                {{ $t('deposit.label.other') }}
                                            </span>
                                        </div>
                                        <p>{{ subtotalPrepaid | toCurrency }} DKK</p>
                                    </div>
                                    <div class="info">
                                        <div>
                                            <p>{{ $t('digital.tabs.review.firstmonthrent') }}</p>
                                            <span v-if="contractData.occupancyDate">
                                                {{
                                                    dateFormat(contractData.occupancyDate)
                                                }} til {{ dateFormat(lastDayOfOccupationMonth) }}
                                            </span>
                                        </div>
                                        <p>{{ Number(contractData.firstMonthRent) | toCurrency }} DKK</p>
                                    </div>
                                    <div class="info">
                                        <div>
                                            <p>{{ $t('digital.tabs.review.firstmonthonaccount') }}</p>
                                            <span v-if="contractData.occupancyDate">
                                                {{
                                                    dateFormat(contractData.occupancyDate)
                                                }} til {{ dateFormat(lastDayOfOccupationMonth) }}
                                            </span>
                                        </div>
                                        <p>{{ Number(contractData.firstMonthOnAccount) | toCurrency }} DKK</p>
                                    </div>
                                    <div class="info">
                                        <p>{{ $t('digital.tabs.review.firstmonthfees') }}</p>
                                        <p>{{ firstMonthFees | toCurrency }} DKK</p>
                                    </div>
                                </div>
                                <div class="content total">
                                    <div class="info">
                                        <p>{{ $t('digital.tabs.review.total') }}</p>
                                        <p>{{ firstPayment | toCurrency }} DKK</p>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="box calculate">
                                <div class="content">
                                    <div class="info">
                                        <div>
                                            <p>{{$t('payments.summary.deposit')}}</p>
                                            <span class="small-text">{{$t('payments.summary.deposit-payment')}}</span>
                                        </div>
                                        <p>{{ subtotalDeposit }} DKK</p>
                                    </div>
                                    <div class="info">
                                        <div>
                                            <p>{{$t('payments.summary.prepaid-rent')}}</p>
                                            <span class="small-text">{{$t('payments.summary.prepaid-rent-payment')}}</span>
                                        </div>
                                        <p>{{ subtotalPrepaid }} DKK</p>
                                    </div>
                                </div>
                                <div class="content total">
                                    <div class="info">
                                        <p>{{$t('summary.total')}}</p>
                                        <p>{{ subtotalPrepaid + subtotalDeposit }} DKK</p>
                                    </div>
                                </div>
                            </div> -->
                        </div>

                        <div class="seperator"></div>

                        <button v-if="showNextStep" v-on:click="tabStep(1)" class="purple next-btn">
                            {{ $t('digital.tabs.nextstep') }}
                        </button>

                    </tab>

                    <!-- DEPOSIT & RENT TAB END -->

                    <!-- ACCESS AND FIXTURES START -->
                    <tab :name="$t('digital.tabs.access.tabname')" id="tab-access">
                        <div class="tab-top">
                            <h2>{{ $t('digital.tabs.access.headline') }}</h2>
                            <p>{{ $t('digital.tabs.access.text') }}</p>
                        </div>

                        <div class="seperator"></div>

                        <div class="wizard-component checkboxes">
                            <p class="subject">{{ $t('digital.tabs.access.access-to') }}</p>
                            <div v-for="access in contractData.access" class="checkbox-list">
                                <label class="custom-checkbox">
                                    <input :readonly="readOnlyFields" type="checkbox"
                                           v-model="contractData.access[access.id].checked">
                                    <span class="checkbox">
                                        <SvgIcon icon="checkmark-input"/>
                                    </span>
                                    <p>{{ $t(access.name) }}</p>
                                </label>
                                <div
                                    v-if="contractData.access[access.id].checked && (access.useNumeration || access.extras.length > 0)"
                                    class="checkbox-choices choices-dropdown">
                                    <div class="arrow-up">
                                        <SvgIcon icon="arrow-up"/>
                                    </div>
                                    <div class="content">
                                        <input :readonly="readOnlyFields" type="text"
                                               v-model="contractData.access[access.id].numeration"
                                               :placeholder="$t('digital-contract.access.number-example')"
                                               style="display:inline-block!important;">
                                    </div>
                                    <div v-for="(extra,extraIdx) in access.extras" class="content">
                                        {{ $t(extra.label) }} {{ extra.suffix }}
                                        <form>
                                            <input :readonly="readOnlyFields" v-model="extra.value" type="text"
                                                   style="display:inline-block!important;" autofill="off"
                                                   autocomplete="false">
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div class="inputs">
                                <div class="add-more">
                                    <div v-for="(extraAccess,idx) in contractData.extraAccess" class="input-new">
                                        <div class="input-container double">
                                            <div class="input-inner area-input">
                                                <input type="text" v-model="extraAccess.name"
                                                       :placeholder="$t('placeholder.add-access')"/>
                                            </div>
                                        </div>
                                        <div class="input-container double">
                                            <div class="input-inner area-input">
                                                <input type="number" v-model="extraAccess.numeration"
                                                       :placeholder="$t('placeholder.access-number-example')"/>
                                            </div>
                                        </div>
                                        <div v-on:click="deleteExtraAccess(idx)" class="delete">
                                            <SvgIcon icon="delete"/>
                                        </div>
                                    </div>
                                    <button v-if="contractData.extraAccess.length < 1" class="green"
                                            v-on:click="addAccess">
                                        <SvgIcon icon="plus-circle"/>
                                        {{ $t('button.add.access') }}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="seperator"></div>

                        <div class="wizard-component checkboxes">
                            <p class="subject">{{ $t('digital.tabs.usage.label') }}</p>
                            <p>{{ $t('digital.tabs.usage.text') }}</p><br>

                            <div class="radio-buttons">
                                <label for="usage-one" class="custom-radio">
                                    <input :readonly="readOnlyFields"
                                           type="radio"
                                           id="usage-one"
                                           value="1"
                                           v-model="contractData.limitedTenantChildren"/>
                                    <span class="radio-circle"></span>
                                    <!-- <p>{{ $t('digital.tabs.usage.checkbox-label') }}</p> -->
                                    <p>Beboelse for lejer(e)</p>
                                </label>
                                <label for="usage-two" class="custom-radio">
                                    <input :readonly="readOnlyFields"
                                           type="radio"
                                           id="usage-two"
                                           value="2"
                                           v-model="contractData.limitedTenantChildren"/>
                                    <span class="radio-circle"></span>
                                    <p>Beboelse for lejer(e) med husstand</p>
                                    <!-- <p>{{ $t('digital.tabs.usage-with-sublet.checkbox-label') }}</p> -->
                                </label>
                                <label for="usage-three" class="custom-radio">
                                    <input :readonly="readOnlyFields"
                                           type="radio"
                                           id="usage-three"
                                           value="3"
                                           v-model="contractData.limitedTenantChildren"/>
                                    <span class="radio-circle"></span>
                                    <p>Beboelse for lejers medarbejder og dennes husstand</p>
                                    <!-- <p>{{ $t('digital.tabs.usage-with-sublet.checkbox-label') }}</p> -->
                                </label>
                                <label for="usage-four" class="custom-radio">
                                    <input :readonly="readOnlyFields"
                                           type="radio"
                                           id="usage-four"
                                           value="4"
                                           v-model="contractData.limitedTenantChildren"/>
                                    <span class="radio-circle"></span>
                                    <p>Fremleje til beboelse</p>
                                    <!-- <p>{{ $t('digital.tabs.usage-with-sublet.checkbox-label') }}</p> -->
                                </label>
                            </div>

                            <!-- <div class="checkbox-list">
                                <label class="custom-checkbox">
                                    <input :readonly="readOnlyFields" type="checkbox" v-model="contractData.limitedTenantChildren">
                                    <span class="checkbox">
                                        <SvgIcon icon="checkmark-input" />
                                    </span>
                                    <p>{{ $t('digital.tabs.usage.checkbox-label') }}</p>
                                </label>
                            </div> -->
                        </div>

                        <div class="seperator"></div>

                        <div class="wizard-component checkboxes">
                            <p class="subject">{{ $t('digital.tabs.access.amenities') }}</p>
                            <div v-for="amenity in contractData.amenities" class="checkbox-list">
                                <label class="custom-checkbox">
                                    <input :readonly="readOnlyFields" type="checkbox"
                                           v-model="contractData.amenities[amenity.id].checked">
                                    <span class="checkbox">
                                        <SvgIcon icon="checkmark-input"/>
                                    </span>
                                    <p>{{ $t(amenity.name) }}</p>
                                </label>
                                <div v-if="contractData.amenities[amenity.id].checked && amenity.useNumeration"
                                     class="checkbox-choices choices-dropdown">
                                    <div class="arrow-up">
                                        <SvgIcon icon="arrow-up"/>
                                    </div>
                                    <div class="content">
                                        <input :readonly="readOnlyFields" type="text"
                                               v-model="contractData.amenities[amenity.id].numeration"
                                               placeholder="Antal" style="display:inline-block!important;">
                                    </div>
                                </div>
                            </div>

                            <div class="inputs">
                                <div class="add-more">
                                    <div v-for="(extraAmenity, i) in contractData.extraAmenities" :key="i"
                                         class="input-new">
                                        <div class="input-container">
                                            <div class="input-inner area-input">
                                                <form>
                                                    <input :readonly="readOnlyFields" type="text"
                                                           :placeholder="$t('add-amenities.placeholder')"
                                                           v-model="contractData.extraAmenities[i].name" autofill="off"
                                                           autocomplete="false" autofocus/>
                                                </form>
                                                <div v-on:click="deleteExtraAmenity(i)" class="delete">
                                                    <SvgIcon icon="delete"/>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <button v-if="contractData.extraAmenities.length < 3"
                                            @click.prevent="addExtraAmenity()" class="green">
                                        <SvgIcon icon="plus-circle"/>
                                        {{ $t('button.add.amenity-item') }}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="seperator"></div>

                        <button v-if="showNextStep" v-on:click="tabStep(1)" class="purple next-btn">
                            {{ $t('digital.tabs.nextstep') }}
                        </button>

                    </tab>

                    <!-- MAINTENANCE TAB START -->
                    <tab :name="$t('digital.tabs.maintenance.tabname')" id="tab-maintenance">
                        <div class="tab-top">
                            <h2>{{ $t('digital.tabs.maintenance.headline') }}</h2>
                            <p>{{ $t('digital.tabs.maintenance.text') }}</p>
                        </div>

                        <div class="seperator"></div>

                        <div class="wizard-component checkboxes">
                            <div class="checkbox-list">
                                <p class="subject">{{ $t('digital.tabs.maintenance.movingin-report-label') }}</p>
                                <label class="custom-checkbox">
                                    <input
                                        :readonly="readOnlyFields"
                                        type="checkbox"
                                        v-model="contractData.inspectionBeforeMovingIn"
                                        @change="pushSpecialConditions"
                                    />
                                    <span class="checkbox">
                                        <SvgIcon icon="checkmark-input"/>
                                    </span>
                                    <p>{{ $t('digital.tabs.maintenance.movingin-report') }}</p>
                                </label>
                                <div v-if="contractData.inspectionBeforeMovingIn"
                                     class="checkbox-choices choices-dropdown">
                                    <div class="arrow-up">
                                        <SvgIcon icon="arrow-up"/>
                                    </div>
                                    <div class="content moving-in-report-date">
                                        <p class="subject">{{ $t('digital.tabs.maintenance.time') }}</p>
                                        <div class="date-input input-inner">
                                            <DateTimeInput
                                                id="inspectionBeforeMovingInDate"
                                                :readonly="readOnlyFields"
                                                :time="true"
                                                :value="contractData.inspectionBeforeMovingInDate"
                                                @change="pushSpecialConditions"
                                            />
                                            <span class="label-after">
                                                <SvgIcon icon="calendar"/>
                                            </span>
                                        </div>
                                        <div class="calendar-delete"
                                             @click="contractData.inspectionBeforeMovingInDate = ''">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                 viewBox="0 0 20 24">
                                                <path
                                                    d="M3752,580a2,2,0,0,0,2,2h12a2,2,0,0,0,2-2V566h-16v14Zm16-20h-4a2,2,0,0,0-2-2h-4a2,2,0,0,0-2,2h-4a2,2,0,0,0,0,4h16A2,2,0,0,0,3768,560Zm-11,9a2,2,0,0,1,2,2v6a2,2,0,0,1-4,0v-6A2,2,0,0,1,3757,569Zm6,0a2,2,0,0,1,2,2v6a2,2,0,0,1-4,0v-6A2,2,0,0,1,3763,569Z"
                                                    transform="translate(-3750 -558)" class="fill-color"></path>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="seperator"></div>

                        <div class="wizard-component radio-buttons with-checkboxes">
                            <div class="input-inner area-input">
                                <p class="subject">{{ $t('digital.tabs.maintenance.by') }}</p>
                                <label for="maintenance-by-landlord" class="custom-radio">
                                    <input :readonly="readOnlyFields" type="radio" id="maintenance-by-landlord"
                                           :value="1" v-model="contractData.maintenanceBy"/>
                                    <span class="radio-circle"></span>
                                    <p>{{ $t('digital.tabs.maintenance.bylandlord') }}</p>
                                </label>
                                <div v-if="contractData.maintenanceBy == '1'" class="checkbox-choices choices-dropdown">
                                    <div class="arrow-up">
                                        <SvgIcon icon="arrow-up"/>
                                    </div>
                                    <div class="content">
                                        <p class="subject">{{ $t('digital.tabs.maintenance.cost') }}</p>
                                        <div class="date-input input-inner">
                                            <!-- <input :readonly="readOnlyFields" type="number" name="" v-model="contractData.maintenanceAccount"> -->

                                            <vue-numeric
                                                :read-only="readOnlyFields"
                                                :currency="inputCurrency"
                                                :separator="inputSeparator"
                                                :precision="0"
                                                v-model="contractData.maintenanceAccount"
                                            />
                                            <span class="label-after">Kr.</span>
                                        </div>
                                    </div>
                                </div>
                                <label class="custom-radio">
                                    <input :readonly="readOnlyFields" type="radio" id="maintenance-by-tenant" :value="0"
                                           v-model="contractData.maintenanceBy"/>
                                    <span class="radio-circle"></span>
                                    <p>{{ $t('digital.tabs.maintenance.bytenant') }}</p>
                                </label>
                            </div>
                        </div>

                        <div class="seperator"></div>

                        <div class="wizard-component radio-buttons with-checkboxes">
                            <div class="input-inner area-input">
                                <p class="subject">{{ $t('digital.tabs.maintenance-outdoor.by') }}</p>
                                <label for="maintenance-outdoor-by-landlord" class="custom-radio">
                                    <input
                                        :readonly="readOnlyFields"
                                        type="radio"
                                        id="maintenance-outdoor-by-landlord"
                                        :value="1"
                                        v-model="contractData.maintenanceOutdoorBy"
                                        @change="pushSpecialConditions"
                                    />
                                    <span class="radio-circle"></span>
                                    <p>{{ $t('digital.tabs.maintenance-outdoor.bylandlord') }}</p>
                                </label>
                                <label class="custom-radio">
                                    <input
                                        :readonly="readOnlyFields"
                                        type="radio"
                                        id="maintenance-outdoor-by-tenant"
                                        :value="0"
                                        v-model="contractData.maintenanceOutdoorBy"
                                        @change="pushSpecialConditions"
                                    />
                                    <span class="radio-circle"></span>
                                    <p>{{ $t('digital.tabs.maintenance-outdoor.bytenant') }}</p>
                                </label>
                            </div>
                        </div>

                        <div class="seperator"></div>

                        <button v-if="showNextStep" v-on:click="tabStep(1)" class="purple next-btn">
                            {{ $t('digital.tabs.nextstep') }}
                        </button>

                    </tab>
                    <!-- MAINTENANCE TAB END -->


                    <!-- OTHERS TAB START -->
                    <tab :name="$t('digital.tabs.other.tabname')" id="tab-other">
                        <div class="tab-top">
                            <h2>{{ $t('digital.tabs.others.headline') }}</h2>
                            <p>{{ $t('digital.tabs.others.text') }}</p>
                        </div>

                        <div class="seperator"></div>

                        <div class="wizard-component checkboxes">
                            <div class="checkbox-list">

                                <label class="custom-checkbox">
                                    <input
                                        :readonly="readOnlyFields"
                                        type="checkbox"
                                        v-model="contractData.allowElectronicCommunication"
                                        @change="pushSpecialConditions"
                                    />
                                    <span class="checkbox">
                                        <SvgIcon icon="checkmark-input"/>
                                    </span>
                                    <p>{{ $t('digital.tabs.allow-communication') }}</p>
                                </label>

                                <label class="custom-checkbox">
                                    <input
                                        type="checkbox"
                                        :readonly="readOnlyFields"
                                        @change="pushSpecialConditions"
                                        v-model="contractData.standardRentRegulation"/>
                                    <span class="checkbox">
                                        <SvgIcon icon="checkmark-input"/>
                                    </span>
                                    <p>{{ $t('digital.tabs.standard-house-regulation') }}</p>
                                </label>
                                <label class="custom-checkbox">
                                    <input
                                        :readonly="readOnlyFields"
                                        type="checkbox"
                                        v-model="contractData.energyRank"
                                        @change="pushSpecialConditions"
                                    >
                                    <span class="checkbox">
                                        <SvgIcon icon="checkmark-input"/>
                                    </span>
                                    <p>{{ $t('digital.tabs.energy') }}</p>
                                </label>
                                <div v-if="contractData.energyRank" class="upload-input">
                                    <vue-dropzone ref="uploadEnergyRank" id="uploadEnergyRank"
                                                  :options="energyRankUploadOptions"
                                                  @vdropzone-success="energyRankUploadSuccess" class="dropzone"
                                                  v-if="!contractData.energyRankPdf"
                                                  @vdropzone-error="customUploadError"
                                    ></vue-dropzone>
                                    <div v-if="contractData.energyRankPdf">
                                        <div class="uploaded-files">
                                            <ul>
                                                <li>
                                                    <div class="icon">
                                                        <img src="/images/SVG/Pdf.svg" alt="">
                                                    </div>
                                                    <div class="info-content">
                                                        <p class="file-name">{{
                                                                contractData.energyRankPdf.filename
                                                            }}</p>
                                                        <span class="size-info">{{
                                                                contractData.energyRankPdf.size | megabytes
                                                            }}</span>
                                                    </div>
                                                    <div class="delete">
                                                        <img src="/images/SVG/Delete.svg" alt=""
                                                             v-on:click="deleteUpload('energy-rank')">
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="tipsbox">
                                        <div class="icon">
                                            <SvgIcon icon="tips-info"/>
                                        </div>
                                        <div class="text">
                                            <p>{{ $t('digital.tabs.energy-tipsbox') }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="seperator"></div>

                        <div class="wizard-component radio-buttons with-checkboxes">
                            <div class="input-inner area-input">
                                <p class="subject">{{ $t('digital.tabs.legal.petsallowed') }}</p>
                                <label class="custom-radio">
                                    <input
                                        :readonly="readOnlyFields"
                                        type="radio"
                                        id="petsAllowedOne"
                                        :value="0"
                                        @change="pushSpecialConditions"
                                        v-model="contractData.petsAllowed">
                                    <span class="radio-circle"></span>
                                    <p>{{ $t('digital.tabs.legal.petsallowed-no') }}</p>
                                </label>
                                <label class="custom-radio">
                                    <input
                                        :readonly="readOnlyFields"
                                        type="radio"
                                        id="petsAllowedTwo"
                                        :value="1"
                                        @change="pushSpecialConditions"
                                        v-model="contractData.petsAllowed">
                                    <span class="radio-circle"></span>
                                    <p>{{ $t('digital.tabs.legal.petsallowed-maybe') }}</p>
                                </label>
                                <label class="custom-radio">
                                    <input
                                        :readonly="readOnlyFields"
                                        type="radio"
                                        id="petsAllowedThree"
                                        :value="2"
                                        @change="pushSpecialConditions"
                                        v-model="contractData.petsAllowed">
                                    <span class="radio-circle"></span>
                                    <p>{{ $t('digital.tabs.legal.petsallowed-yes') }}</p>
                                </label>
                            </div>
                        </div>

                        <div class="seperator"></div>

                        <div class="wizard-component radio-buttons with-checkboxes">
                            <p class="subject">{{ $t('digital.tabs.legal.house-rules') }}</p>
                            <label class="custom-radio">
                                <input
                                    :readonly="readOnlyFields"
                                    type="radio"
                                    id="houseRoulesYes"
                                    :value="true"
                                    v-model="contractData.houseRulesIssued"
                                    @change="pushSpecialConditions"
                                >
                                <span class="radio-circle"></span>
                                <p>{{ $t('digital.tabs.legal.houseroules-yes') }}</p>
                            </label>
                            <div v-if="contractData.houseRulesIssued" class="upload-input">
                                <div>
                                    <vue-dropzone ref="uploadHouseRules" id="uploadHouseRules"
                                                  :options="houseRulesUploadOptions"
                                                  @vdropzone-success="houseRulesUploadSuccess"
                                                  class="dropzone"
                                                  v-if="!contractData.houseRulesPdf"
                                                  @vdropzone-error="customUploadError"
                                    ></vue-dropzone>
                                </div>
                                <div v-if="contractData.houseRulesPdf">
                                    <div class="uploaded-files">
                                        <ul>
                                            <li>
                                                <div class="icon">
                                                    <img src="/images/SVG/Pdf.svg" alt="">
                                                </div>
                                                <div class="info-content">
                                                    <p class="file-name">{{ contractData.houseRulesPdf.filename }}</p>
                                                    <span class="size-info">{{
                                                            contractData.houseRulesPdf.size | megabytes
                                                        }}</span>
                                                </div>
                                                <div class="delete">
                                                    <img src="/images/SVG/Delete.svg" alt=""
                                                         v-on:click="deleteUpload('house-rules')">
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <label class="custom-radio">
                                <input
                                    :readonly="readOnlyFields"
                                    type="radio"
                                    id="houseRoulesNo"
                                    :value="false"
                                    v-model="contractData.houseRulesIssued"
                                    @change="pushSpecialConditions"
                                >
                                <span class="radio-circle"></span>
                                <p>{{ $t('digital.tabs.legal.houseroules-no') }}</p>
                            </label>
                        </div>

                        <div class="seperator"></div>

                        <div class="wizard-component radio-buttons with-checkboxes">
                            <div class="input-inner area-input">
                                <p class="subject">{{ $t('digital.tabs.smoking') }}</p>
                                <label class="custom-radio">
                                    <input
                                        type="radio"
                                        :readonly="readOnlyFields"
                                        id="smokingallowedYes"
                                        :value="true"
                                        v-model="contractData.smokingAllowed"
                                        @change="pushSpecialConditions"
                                    >
                                    <span class="radio-circle"></span>
                                    <p>{{ $t('digital.tabs.smokingallowed-yes') }}</p>
                                </label>
                                <label class="custom-radio">
                                    <input
                                        :readonly="readOnlyFields"
                                        type="radio"
                                        id="smokingallowedNo"
                                        :value="false"
                                        v-model="contractData.smokingAllowed"
                                        @change="pushSpecialConditions"
                                    >
                                    <span class="radio-circle"></span>
                                    <p>{{ $t('digital.tabs.smokingallowed-no') }}</p>
                                </label>
                            </div>
                        </div>

                        <div class="seperator"></div>

                        <div class="wizard-component">
                            <div class="inputs">
                                <div class="input-container">
                                    <p class="subject">{{ $t('digital.paragraph10.label') }}</p>
                                    <div class="input-inner">
                                        <textarea v-model="contractData.paragraph10"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="seperator"></div>

                        <div class="wizard-component">
                            <div class="input-inner area-input additional-files">
                                <p class="subject">{{ $t('digital.tabs.other.additional-files') }}</p>
                                <div class="popup uploaded-files">
                                    <ul>
                                        <li v-for="file in customUploads">
                                            <div class="info-content">
                                                <div class="icon">
                                                    <img src="/images/SVG/Pdf.svg" alt="">
                                                </div>
                                                <p class="file-name">{{ file.filename }}</p>
                                                <!-- <span class="size-info">{{parseFloat( parseFloat(file.size) / (1024 *1024)).toFixed(2)}} MB</span> -->
                                            </div>
                                            <div class="input-container">
                                                <input type="text" v-bind:class="{ active: true }" v-model="file.name"
                                                       v-on:change="updateCustomUploadName(file.id)"
                                                       :placeholder="$t('additional-files.input.placeholder')">
                                            </div>
                                            <div class="delete">
                                                <img src="/images/SVG/Delete.svg"
                                                     v-on:click="deleteCustomUpload(file.id)">
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <vue-dropzone
                                    ref="customUpload"
                                    id="dropzoneCustomUpload"
                                    :options="customUploadDropzoneOptions"
                                    @vdropzone-success="customUploadSuccess"
                                    @vdropzone-error="customUploadError"></vue-dropzone>
                            </div>
                        </div>

                        <div class="seperator"></div>
                        <button v-if="showNextStep" v-on:click="tabStep(1)" class="purple next-btn">
                            {{ $t('digital.tabs.nextstep') }}
                        </button>


                    </tab>
                    <!-- OTHERS TAB END -->

                    <!-- SPECIAL CONDITIONS TAB START -->
                    <tab :name="$t('digital.tabs.special-conditions.tabname')" id="tab-special-conditions">
                        <div class="tab-top">
                            <h2>{{ $t('contract.special-conditions.headline') }}</h2>
                            <p>{{ $t('contract.special-conditions.text') }}</p>

                            <label class="switch purple" v-if="customSpecialConditionsEditorAvailable">
                                <p>{{ $t('digital.tabs.special_conditions_default') }}</p>
                                <input
                                    type="checkbox"
                                    id="special-conditions-mode"
                                    v-model="contractData.special_conditions_mode"
                                    :true-value="1"
                                    :false-value="2"
                                    @change="pushSpecialConditions"
                                >
                                <div class="slider"></div>
                                <p>{{ $t('digital.tabs.special_conditions_custom_text') }}</p>
                            </label>
                        </div>

                        <div class="seperator"></div>

                        <SpecialConditions
                            @disable="specialConditionDisabledCallback"
                            @enable="specialConditionEnabledCallback"
                            @save="save"
                            ref="specialConditionsEditor"
                            v-show="contractData.special_conditions_mode === 1 || !customSpecialConditionsEditorAvailable"
                            v-model="contractData"
                        />

                        <CustomTextConditions
                            v-show="contractData.special_conditions_mode === 2 && customSpecialConditionsEditorAvailable"
                            v-model="contractData.special_conditions_text"
                            :default-text="custom_special_conditions_text"
                        />

                        <div class="seperator"></div>
                        <button v-if="showNextStep" v-on:click="tabStep(1)" class="purple next-btn">
                            {{ $t('digital.tabs.nextstep') }}
                        </button>

                    </tab>
                    <!-- SPECIAL CONDITIONS TAB START -->

                    <!-- LANDLORD TAB START -->
                    <tab :name="$t('digital.tabs.landlord.tabname')" id="tab-landlord">
                        <div class="tab-top">
                            <h2>{{ $t('digital.tabs.landlord.headline') }}</h2>
                            <p>{{ $t('digital.tabs.landlord.text') }}</p>
                        </div>
                        <div class="seperator"></div>
                        <div class="wizard-component data-input" v-if="getSubscriptionId > 1">
                            <p class="subject">{{ $t('digital.tabs.onbehalf-label') }}</p>
                            <div class="double-radio">
                                <label for="onBehalfLandlordYes" class="custom-radio">
                                    <input :readonly="readOnlyFields" id="onBehalfLandlordYes" type="radio"
                                           :value="true" v-model="usingBehalfOfLandlord"/>
                                    <span class="radio-circle"></span>
                                    <p>{{ $t('general.label.yes') }}</p>
                                </label>
                                <label for="onBehalfLandlordNo" class="custom-radio">
                                    <input :readonly="readOnlyFields" id="onBehalfLandlordNo" type="radio"
                                           :value="false" v-model="usingBehalfOfLandlord"/>
                                    <span class="radio-circle"></span>
                                    <p>{{ $t('general.label.no') }}</p>
                                </label>
                            </div>
                        </div>
                        <div class="wizard-component data-input disabled-wizard-component" v-else>
                            <p class="subject"><span>{{ $t('digital.tabs.onbehalf-label') }}</span>
                                <svg width="51.5" height="20" viewBox="0 0 103 40">
                                    <path id="PRO" style="fill: #7129e9; fill-rule: evenodd;"
                                          d="M1636,483h-87a8,8,0,0,1-8-8V451a8,8,0,0,1,8-8h87a8,8,0,0,1,8,8v24A8,8,0,0,1,1636,483Zm4-32a4,4,0,0,0-4-4h-87a4,4,0,0,0-4,4v24a4,4,0,0,0,4,4h87a4,4,0,0,0,4-4V451ZM1619.34,472.4c-4.93,0-8.3-3.621-8.3-8.991,0-5.419,3.37-9.016,8.3-9.016,4.98,0,8.33,3.6,8.33,9.016C1627.67,468.8,1624.27,472.4,1619.34,472.4Zm0-14.681c-2.93,0-4.83,2.143-4.83,5.69,0,3.522,1.9,5.665,4.83,5.665,2.96,0,4.83-2.192,4.83-5.665C1624.17,459.881,1622.3,457.714,1619.34,457.714Zm-12.94,14.262-4.04-6.971h-1.75v6.971h-3.44V454.807h5.81c4.21,0,5.91,1.946,5.91,5a4.588,4.588,0,0,1-3.08,4.755l4.61,7.414h-4.02Zm-3.77-13.991h-2.02V461.8h2.02c1.61,0,2.79-.3,2.79-1.946C1605.42,458.231,1604.24,457.985,1602.63,457.985Zm-13.92,6.971h-2.36v7.02h-3.45V454.807h5.81c3.92,0,5.92,1.65,5.92,5C1594.63,463.182,1592.58,464.956,1588.71,464.956Zm-0.34-6.971h-2.02v3.793h2.02c1.87,0,2.78-.468,2.78-1.921C1591.15,458.428,1590.31,457.985,1588.37,457.985ZM1573,473h-14a2,2,0,0,1-2-2v-8a2,2,0,0,1,2-2h1v-2a6,6,0,0,1,12,0v2h1a2,2,0,0,1,2,2v8A2,2,0,0,1,1573,473Zm-4.99-14a2,2,0,0,0-2-2h-0.02a2,2,0,0,0-2,2v2h4.02v-2Z"
                                          transform="translate(-1541 -443)"/>
                                </svg>
                            </p>

                            <div class="double-radio">
                                <label class="custom-radio">
                                    <input type="radio" disabled="disabled"/>
                                    <span class="radio-circle"></span>
                                    <p>{{ $t('general.label.yes') }}</p>
                                </label>
                                <label class="custom-radio">
                                    <input type="radio" disabled="disabled" checked="checked"/>
                                    <span class="radio-circle"></span>
                                    <p>{{ $t('general.label.no') }}</p>
                                </label>
                            </div>
                        </div>

                        <div v-if="usingBehalfOfLandlord" class="wizard-component data-input">
                            <p class="subject">{{ $t('digital.tabs.signing-landlord') }}</p>
                            <div class="double-radio">
                                <label for="signingLandlordYes" class="custom-radio">
                                    <input :readonly="readOnlyFields" id="signingLandlordYes" type="radio" :value="true"
                                           v-model="behalfOfLandlordMustApprove"/>
                                    <span class="radio-circle"></span>
                                    <p>{{ $t('general.label.yes') }}</p>
                                </label>
                                <label for="signingLandlordNo" class="custom-radio">
                                    <input :readonly="readOnlyFields" id="signingLandlordNo" type="radio" :value="false"
                                           v-model="behalfOfLandlordMustApprove"/>
                                    <span class="radio-circle"></span>
                                    <p>{{ $t('general.label.no') }}</p>
                                </label>
                            </div>
                        </div>

                        <div class="seperator" v-if="usingBehalfOfLandlord"></div>

                        <landlord-info
                            :draft-contract="draftContract"
                            :using-behalf-of-landlord="usingBehalfOfLandlord"
                            :show-update-button="false"
                            :show-bank-form-fields="false"
                            :show-landlord-type="true"
                            :show-cvr="(usingBehalfOfLandlord !== true) || (usingBehalfOfLandlord && draftContract.definition.landlord_type === 'commercial')"
                            :default-email="getAccountEmail"
                        />

                        <div class="seperator" v-if="getLandlordData.type === 'commercial'"></div>

                        <div class="wizard-component"
                             v-if="getLandlordData.type === 'commercial' || usingBehalfOfLandlord === false">
                            <h2>{{ $t('digital.tabs.payments.bankdetails') }}</h2>
                            <div class="inputs data-input">
                                <div class="input-container double">
                                    <p class="subject">{{ $t('bankRegNo') }}</p>
                                    <div class="input-inner">
                                        <validation-provider rules="required|numeric" v-slot="{failed}" immediate slim>
                                            <input
                                                :class="{'has-error': failed}"
                                                :readonly="readOnlyFields"
                                                type="text"
                                                v-model="contractData.bankRegNo"
                                            />
                                        </validation-provider>
                                    </div>
                                </div>
                                <div class="input-container double">
                                    <p class="subject">{{ $t('bankAccountNo') }}</p>
                                    <div class="input-inner">
                                        <validation-provider rules="required" v-slot="{failed}" immediate slim>
                                            <input
                                                :class="{'has-error': failed}"
                                                :readonly="readOnlyFields"
                                                type="text"
                                                v-model="contractData.bankAccountNo"
                                            />
                                        </validation-provider>
                                    </div>
                                </div>
                                <div class="input-container">
                                    <p class="subject">{{ $t('bankName') }}</p>
                                    <div class="input-inner">
                                        <validation-provider rules="required" v-slot="{failed}" immediate slim>
                                            <input
                                                :class="{'has-error': failed}"
                                                :readonly="readOnlyFields"
                                                type="text"
                                                v-model="contractData.bankName"
                                            />
                                        </validation-provider>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="seperator"></div>

                        <button v-if="showNextStep" v-on:click="tabStep(1)" class="purple next-btn">
                            {{ $t('digital.tabs.nextstep') }}
                        </button>
                    </tab>
                    <!-- LANDLORD TAB END -->

                    <!-- TENANT TAB START -->
                    <tab :name="$t('digital.tabs.tenant.tabname')" id="tab-tenant">
                        <tenant-tab ref="tenantTab" @next="tenantTabNextCallback"/>
                    </tab>
                    <!-- TENANT TAB END -->

                    <!-- REVIEW TAB START -->
                    <tab :name="$t('digital.tabs.review.tabname')">
                        <div class="tab-top">
                            <h2>{{ $t('digital.tabs.review.headline') }}</h2>
                            <p>{{ $t('digital.tabs.review.label') }}</p>
                        </div>
                        <div class="seperator"></div>
                        <div class="wizard-component review">
                            <div class="box">
                                <p class="subject">{{ $t('digital.tabs.review.property') }}</p>
                                <div class="info">
                                    <div class="icon">
                                        <SvgIcon icon="house"/>
                                    </div>
                                    <p>{{ getAddress }}</p>
                                    <!-- <p v-if="contractData.property.address">{{ contractData.property.address }}</p> -->
                                    <!-- <p v-else>{{$t('digital.tabs.review.notspecifiedyet')}}</p> -->
                                </div>
                                <div class="info">
                                    <div class="icon">
                                        <SvgIcon icon="occupancy-calendar"/>
                                    </div>
                                    <p v-if="contractData.occupancyDate">{{ $t('digital.tabs.review.occupancydate') }}:
                                        {{ reviewOccupancyDate }}</p>
                                    <p v-else>{{ $t('digital.tabs.review.notspecifiedyet') }}</p>
                                </div>
                            </div>

                            <div class="box calculate">
                                <div class="content">
                                    <p class="subject">{{ $t('digital.tabs.review.paymentsbeforeoccupancydate') }}</p>
                                    <div class="info">
                                        <div>
                                            <p>{{ $t('digital.tabs.review.deposit') }}</p>
                                            <span v-if="contractData.depositMonths == '0'">
                                                {{ $t('deposit.label.no-deposit') }}
                                            </span>
                                            <span v-if="contractData.depositMonths == '1'">
                                                {{ $t('deposit.label.1month') }}
                                            </span>
                                            <span v-if="contractData.depositMonths == '2'">
                                                {{ $t('deposit.label.2months') }}
                                            </span>
                                            <span v-if="contractData.depositMonths == '3'">
                                                {{ $t('deposit.label.3months') }}
                                            </span>
                                            <span v-if="contractData.depositMonths == 'other'">
                                                {{ $t('deposit.label.other') }}
                                            </span>
                                        </div>
                                        <p>{{ subtotalDeposit | toCurrency }} DKK</p>
                                    </div>
                                    <div class="info">
                                        <div>
                                            <p>{{ $t('digital.tabs.review.prepaidrent') }}</p>
                                            <span v-if="contractData.prepaidMonths == '0'">
                                                {{ $t('prepaid.label.no-prepaid-rent') }}
                                            </span>
                                            <span v-if="contractData.prepaidMonths == '1'">
                                                {{ $t('deposit.label.1month') }}
                                            </span>
                                            <span v-if="contractData.prepaidMonths == '2'">
                                                {{ $t('deposit.label.2months') }}
                                            </span>
                                            <span v-if="contractData.prepaidMonths == '3'">
                                                {{ $t('deposit.label.3months') }}
                                            </span>
                                            <span v-if="contractData.prepaidMonths == 'other'">
                                                {{ $t('deposit.label.other') }}
                                            </span>
                                        </div>
                                        <p>{{ subtotalPrepaid | toCurrency }} DKK</p>
                                    </div>
                                    <div class="info">
                                        <div>
                                            <p>{{ $t('digital.tabs.review.firstmonthrent') }}</p>
                                            <span v-if="contractData.occupancyDate">
                                                {{
                                                    dateFormat(contractData.occupancyDate)
                                                }} til {{ dateFormat(lastDayOfOccupationMonth) }}
                                            </span>
                                        </div>
                                        <p>{{ Number(contractData.firstMonthRent) | toCurrency }} DKK</p>
                                    </div>
                                    <div class="info">
                                        <div>
                                            <p>{{ $t('digital.tabs.review.firstmonthonaccount') }}</p>
                                            <span v-if="contractData.occupancyDate">
                                                {{
                                                    dateFormat(contractData.occupancyDate)
                                                }} til {{ dateFormat(lastDayOfOccupationMonth) }}
                                            </span>
                                        </div>
                                        <p>{{ Number(contractData.firstMonthOnAccount) | toCurrency }} DKK</p>
                                    </div>
                                    <div class="info">
                                        <p>{{ $t('digital.tabs.review.firstmonthfees') }}</p>
                                        <p>{{ firstMonthFees | toCurrency }} DKK</p>
                                    </div>
                                </div>
                                <div class="content total">
                                    <div class="info">
                                        <p>{{ $t('digital.tabs.review.total') }}</p>
                                        <p>{{ firstPayment | toCurrency }} DKK</p>
                                    </div>
                                </div>
                            </div>

                            <div v-if="usingBehalfOfLandlord && behalfOfLandlordMustApprove" class="box preview-box">
                                <div style="display: flex;">
                                    <p class="subject">{{ $t('digital.tabs.review.approval-status') }}</p>
                                    <div style="flex-grow: 1; justify-content: flex-end; display: flex;">
                                        <div v-if="approvalRevokeable">
                                            <button class="purple" :disabled="revokingApproval"
                                                    v-on:click="revokeApproval">
                                                <span
                                                    v-if="!revokingApproval">{{
                                                        $t('digital.behalfoflandlord.revokeapproval')
                                                    }}</span>
                                                <span
                                                    v-if="revokingApproval">{{
                                                        $t('digital.behalfoflandlord.revoking')
                                                    }}</span>
                                            </button>
                                        </div>
                                        <div v-else>
                                            <button class="purple" v-on:click="sendForApproval"
                                                    :disabled="sendingForApproval">
                                                <span v-if="!sendingForApproval && !behalfOfLandlordSentForApproval">
                                                    {{ $t('digital.behalfoflandlord.sendforapproval') }}
                                                </span>
                                                <span v-if="!sendingForApproval && behalfOfLandlordSentForApproval">
                                                    {{ $t('digital.behalfoflandlord.resend') }}
                                                </span>
                                                <span
                                                    v-if="sendingForApproval">{{
                                                        $t('digital.behalfoflandlord.sending')
                                                    }}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="status-box" v-if="behalfOfLandlordMustApprove">
                                    <strong>{{ $t('digital.tabs.review.landlord-confirmation') }}</strong>
                                    <div v-if="!isAwaitingLandlordApproval && !approvedByLandlord"
                                         class="status-box-row">
                                        <div class="dot gray"></div>
                                        {{ $t('digital.tabs.review.not-yet-sent-for-approval') }}
                                    </div>
                                    <div v-if="isAwaitingLandlordApproval" class="status-box-row">
                                        <div class="dot orange"></div>
                                        {{ $t('digital.tabs.review.pending-approval') }}
                                    </div>
                                    <div v-if="approvedByLandlord" class="status-box-row">
                                        <div class="dot green"></div>
                                        {{ $t('digital.tabs.review.approval-confirmed') }}
                                    </div>
                                </div>
                            </div>

                            <div class="box preview-box">
                                <p class="subject">{{ $t('digital.tabs.review.contractsbeingsent') }}</p>
                                <div class="content">
                                    <div class="info">
                                        <div class="icon">
                                            <SvgIcon icon="small-contract"/>
                                        </div>
                                        <p>{{ $t('digital.tabs.review.leasecontract') }}</p>
                                    </div>
                                    <a @click.prevent="createPdf">
                                        <button class="purple" :disabled="generatingPdf">
                                            <span
                                                v-if="generatingPdf">{{
                                                    $t('digital.tabs.review.generatingpdf')
                                                }} ...</span>
                                            <span v-if="!generatingPdf">{{ $t('digital.tabs.review.preview') }}</span>
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="seperator"></div>
                        <button class="purple" :disabled="sendingEmail || !allowSendContract"
                                @click.prevent="sendEmail()">{{ $t('digital.tabs.sendemail') }}
                        </button>
                    </tab>
                    <!-- REVIEW TAB END -->

                    <div class="create-bottom mobile-bottom">
                        <div class="content">
                            <div class="double-buttons button-container">
                                <button :disabled="showPrevStep == false" v-on:click="tabStep(-1)" class="transparent">
                                    <SvgIcon icon="button-prev"/>
                                    {{ $t('digital.previousstep') }}
                                </button>
                                <button :disabled="showNextStep == false" v-on:click="tabStep(1)" class="transparent">
                                    {{ $t('digital.tabs.nextstep') }}
                                    <SvgIcon icon="button-next"/>
                                </button>
                            </div>

                            <div class="button-container">
                                <button @click.prevent="createPdf" :disabled="generatingPdf" class="transparent">
                                    <span v-if="generatingPdf">{{ $t('digital.tabs.review.generatingpdf') }} ...</span>
                                    <span v-if="!generatingPdf">{{ $t('digital.tabs.review.preview') }}</span>
                                </button>

                                <button class="transparent" :disabled="saveDraftButtonDisabled || readOnlyFields"
                                        @click.prevent="save()">
                                    <span v-if="saveDraftButtonDisabled">{{ $t('digital.saving') }} ...</span>
                                    <span v-if="!saveDraftButtonDisabled">{{ $t('button.save.label') }}</span>
                                </button>
                                <!--  -->
                            </div>
                        </div>
                    </div>

                </tabs>
            </div>
        </div>

    </div>
</template>

<script>
import Vue from 'vue';
import {mapGetters} from 'vuex';
import SpecialConditions from './parts/SpecialConditions';
import RadioButtons from './parts/RadioButtons';
import RadioButtonsCheckbox from './parts/RadioButtonsCheckbox';
import RadioButtonsDate from './parts/RadioButtonsDate';
import Checkboxes from './parts/Checkboxes';
import Inputs from './parts/Inputs';
import UploadButton from './parts/UploadButton';
import Textareas from './parts/Textareas';
import Tipsbox from './parts/Tipsbox';
import SelectField from './parts/SelectField';
import RangeInput from './parts/QuanityField';
import {Datetime} from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import VueNumeric from 'vue-numeric';
import ContractPreview from '../../components/ContractPreview.vue';

import LandlordInfo from './parts/LandlordInfo';
import TenantInfo from './parts/TenantInfo';
import Review from './parts/Review';

import SuccessBar from '../../components/SuccessBar.vue';
import Loader from '../../components/Loader.vue';
import DateTimeInput from '../../components/DateTimeInput.vue';
import {store} from '../../store/index';


import CustomTextConditions from "./parts/CustomTextConditions";
import TenantTab from "./tabs/TenantTab";

import Modal from '../../components/Modal';

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('DD-MM-YYYY')
    }
});

Vue.use(VueNumeric);

export default {
    filters: {
        megabytes: function (value) {
            return (value / 1024 / 1024).toFixed(2) + " MB";
        }
    },
    data: () => ({
        draftContract: {},
        address1: '',
        openOverviewNav: false,
        openTopNav: false,
        testDateFF: '1990-01-01',
        isInApprovalMode: false,
        inputCurrency: '',
        inputSeparator: '.',
        tabTitle: 'Generelt',
        totalSteps: 11,
        currentStep: 1,
        editCondition: false,
        showSupplyDetails: false,
        electricityRadios: '',

        accountingModes: {
            onaccount: {},
            included_in_rent: {},
            third_party: {}
        },
        showLoader: true,
        supplyElements: {
            heating: {
                enableThirdPartyOption: true,
                enableNoneOption: false,
                thirdPartySpecialConditionRole: 'heating-third-party',
                customizable: {
                    label: 'supply.heating.other',
                    model: 'heatingOtherSource'
                },
                sources: [
                    {
                        id: 1,
                        label: 'supply.heating.naturegas',
                        accountingMode: ['onaccount', 'included_in_rent']
                    },
                    {
                        id: 2,
                        label: 'supply.heating.central-heat',
                        accountingMode: ['onaccount', 'included_in_rent']
                    },
                    {
                        id: 3,
                        label: 'supply.heating.electric',
                        accountingMode: ['onaccount', 'included_in_rent']
                    },
                    {
                        id: 4,
                        label: 'supply.heating.electric',
                        accountingMode: ['third_party']
                    },
                    {
                        id: 5,
                        label: 'supply.heating.gas',
                        accountingMode: ['third_party']
                    },
                    {
                        id: 6,
                        label: 'supply.heating.oil-petrol',
                        accountingMode: ['third_party']
                    },
                    {
                        id: 7,
                        label: 'supply.heating.remote-heating-naturegas',
                        accountingMode: ['third_party']
                    }
                ]
            },
            water: {
                enableThirdPartyOption: true,
                thirdPartySpecialConditionRole: 'water-third-party',
                enableNoneOption: false
            },
            // electricity: {
            //     enableThirdPartyOption: true,
            //     thirdPartySpecialConditionRole: 'electricity-third-party',
            //     enableNoneOption: false
            // },
            cooling: {
                enableThirdPartyOption: false,
                enableNoneOption: true
            }
        },

        successBarMessage: '',
        picked: '',
        houseRoules: '',
        smokingAllowed: null,

        customUploads: [],

        showPdfViewver: false,
        pdfPreviewUrl: '',

        houseRulesUploadOptions: {},
        energyRankUploadOptions: {},

        approvedByLandlord: false,
        isAwaitingLandlordApproval: false,
        isReadyForSignature: false,

        approvalRevokeable: false,

        specialConditionsLoaded: false,

        custom_special_conditions_text: '',
        custom_special_conditions_enabled: false,
        contractLoaded: false,
        allowAutoSave: false,

        generatingPdf: false,
        property: '',
        storageRoom: '',
        accessOther: '',
        sendingEmail: false,
        saveDraftButtonDisabled: false,
        showNextStep: true,
        showPrevStep: true,
        showSendEmail: false,
        revokingApproval: false,
        usingBehalfOfLandlord: false,
        behalfOfLandlordId: '',
        behalfOfLandlordMustApprove: false,
        behalfOfLandlordEmail: '',
        behalfOfLandlordSentForApproval: false,
        behalfOfLandlordApproved: false,
        sendingForApproval: false,
        heatingShowOther: false,
        version: 1,
        contractData: {
            retainBeforeDeposit: '',
            rentalNo: '',
            otherRentalType: '',
            standardRentRegulation: false,
            allowElectronicCommunication: false,
            limitedTenantChildren: 0,
            smokingAllowed: null,
            paragraph10: '',
            tv: 0,
            energyRank: 0,
            houseRules: '',
            inspectionBeforeMovingInDate: '',
            houseRulesPdf: '',
            energyRankPdf: '',
            tenantEmail: '',
            tenantId: 0,
            access: [],
            amenities: [],
            rentalTypes: [],
            property: '',
            rent: '',
            deposit: '',
            depositMonths: '',
            prepaidRent: '',
            prepaidMonths: '',
            occupancyDate: '',
            limitedRenting: false,
            rentalExpires: '',
            rentalType: '',
            sublease: false,
            representation: false,
            numberOfRooms: 1,
            area: 0,
            areaForBusiness: 0,
            accessible: [],
            accessibleNumbers: {},
            depositPaymentDate: '',
            firstMonthRent: '',
            firstMonthFromDate: '',
            firstMonthToDate: '',
            firstMonthOnAccount: '',
            firstMonthFees: [],
            firstRentPaymentDate: '',
            bankName: '',
            bankRegNo: '',
            bankAccountNo: '',
            monthlyPayDate: '',
            paymentMonthlyOrThirdMonth: 1,
            onAccountTaxationDate: '',
            petsAllowed: null,
            houseRulesIssued: null,
            maintenanceBy: null,
            maintenanceOutdoorBy: null,
            maintenanceAccount: 0,
            inspectionBeforeMovingIn: false,
            sharedSignalSupply: 0,
            tenantThirdPartySignalSupply: 0,
            landlordSuppliesInternetAccess: null,
            heatingAccountingMode: '',
            waterAccountingMode: '',
            electricityAccountingMode: 'third_party_simplex',
            coolingAccountingMode: '',
            waterSupply: '',
            waterIndividualMeasurements: 0,
            coolerIndividualMeasurements: 0,
            electricityIndividualMeasurements: 0,
            heatingIndividualMeasurements: 0,
            electricityAccountedFrom: '',
            heatingAccountedFrom: '',
            waterAccountedFrom: '',
            coolingAccountedFrom: '',
            heatingSource: [],
            heatingOtherSource: '',
            tenants: [],
            tenantHeatingSource: '',
            tenantOtherHeatingSource: '',
            waterHeaterPanels: 0,
            electricityPanels: 0,
            extraAmenities: [],
            extraAccess: [],
            extraOnAccount: [],
            signalSupplyBy: 'onaccount',
            specialConditions: [],
            special_conditions_mode: 1,
            special_conditions_text: '',
            ignore_first_rent_on_move_in: false,
            onAccount: {
                heating: 0,
                water: 0,
                electricity: 0,
                cooling: 0,
                internet: 0,
                antenna: 0,
                representation: 0
            }
        },
    }),
    components: {
        TenantTab,
        CustomTextConditions,
        SpecialConditions,
        RadioButtons,
        RadioButtonsCheckbox,
        RadioButtonsDate,
        Checkboxes,
        Inputs,
        UploadButton,
        Textareas,
        LandlordInfo,
        TenantInfo,
        Tipsbox,
        Review,
        SelectField,
        RangeInput,
        datetime: Datetime,
        vueDropzone: vue2Dropzone,
        SuccessBar,
        Loader,
        VueNumeric,
        DateTimeInput,
        ContractPreview,
        Modal
    },
    computed: {
        ...mapGetters([
            'getSingleProperty',
            'getLandlordData',
            'getTenant',
            'getToken',
            'getSingleDraftContract',
            'isDraftContractSigned',
            'getSubscriptionId',
            'getAccountEmail',
        ]),
        electricitySimplexAvailable() {
            return !moment(this.contractData.occupancyDate).isBefore(moment().subtract(2,'days'), 'day');
        },
        customSpecialConditionsEditorAvailable() {
            return this.custom_special_conditions_enabled || this.contractData.special_conditions_mode === 2;
        },
        electricityAccountingValue() {
            var electricityAccountingMode_value = this.contractData.electricityAccountingMode;

            if(electricityAccountingMode_value) {
                return electricityAccountingMode_value;
            }

            return this.contractData.electricityAccountingMode = 'third_party_simplex';

        },
        electricityRadiosValue() {
            var electricityAccountingMode_value = this.contractData.electricityAccountingMode;


            if( electricityAccountingMode_value === 'onaccount' ) {
                return this.electricityRadios = 'first';
            }
            if( electricityAccountingMode_value === 'included_in_rent' ) {
                return this.electricityRadios = 'first';
            }

            return this.electricityRadios = 'third';

        },
        addressLine1() {
            var address1 = this.getSingleProperty.address ? this.getSingleProperty.address.replace(this.getSingleProperty.zip_code, '').replace(this.getSingleProperty.city, '') : '';
            if (address1) {
                return address1;
            }
            return 'no address';
        },
        getAddress() {
            var address = this.getSingleProperty.address;

            if (address) {
                return address;
            }

            return 'no address';
        },
        allowSendContract() {
            if (!this.behalfOfLandlordMustApprove) {
                return true;
            }

            if (!this.behalfOfLandlordSentForApproval) {
                return false;
            }

            return (!this.isAwaitingLandlordApproval);
        },
        isRentalTerminationValid() {
            if (this.contractData.rentalExpires) {
                return (this.contractData.rentalExpires > this.contractData.occupancyDate);
            }
            return true;
        },
        onAccountTaxationDate() {
            let date = this.contractData.onAccountTaxationDate;
            return date ? this.dateFormat(date) : '-';
        },
        reviewOccupancyDate() {
            let date = this.contractData.occupancyDate;
            return date ? this.dateFormat(date) : '-';
        },
        lastDayOfOccupationMonth() {
            var isQuarterly = this.contractData.paymentMonthlyOrThirdMonth == 2 ? true : false;
            var occupancyDate = this.contractData.occupancyDate;
            if (!occupancyDate) {
                return '';
            }
            var startDate = new Date(occupancyDate);
            if (isQuarterly) {
                var startMonth = startDate.getMonth() + 1;
                for (var i = startMonth; i <= 12; i++) {
                    let m = i < 10 ? '0' + i : i;
                    startDate = new Date(startDate.getFullYear() + '-' + m + '-01');
                    if ([3, 6, 9, 12].indexOf(i) >= 0) {
                        break;
                    }
                }
            }
            var lastDate = startDate;
            while (lastDate.getMonth() == startDate.getMonth()) {
                var currentUnix = lastDate.getTime();
                currentUnix += 24 * 60 * 60 * 1000;
                var testDate = new Date(currentUnix);
                if (testDate.getMonth() == lastDate.getMonth()) {
                    lastDate = testDate;
                } else {
                    break;
                }
            }
            return lastDate;
        },
        subtotalDeposit() {
            let monthlyRent = this.contractData.rent;
            let result = this.contractData.depositMonths && this.contractData.depositMonths != 'other'
                ? (this.contractData.depositMonths * monthlyRent)
                : this.contractData.deposit;

            return result > 0 ? result : 0;
        },
        subtotalPrepaid() {
            let monthlyRent = this.contractData.rent;
            let result = this.contractData.prepaidMonths && this.contractData.prepaidMonths != 'other'
                ? (this.contractData.prepaidMonths * monthlyRent)
                : this.contractData.prepaidRent;

            return result > 0 ? result : 0;
        },
        signedByLandlord() {
            return this.getSingleDraftContract.isSignedByLandlord;
        },
        signedByTenant() {
            return this.getSingleDraftContract.isSigned
        },
        readOnlyFields() {
            return (this.behalfOfLandlordApproved || this.signed_at) ? true : false;
        },
        showHeatSourceOther() {
            return (this.contractData.heatingSource == '');
        },
        firstMonthFees() {
            var total = 0;
            for (var i in this.contractData.firstMonthFees) {
                var fee = this.contractData.firstMonthFees[i];
                total += Number(fee.value) > 0 ? Number(fee.value) : 0;
            }
            return total;
        },
        firstPayment() {
            var addKeys = ['deposit', 'prepaidRent', 'firstMonthRent', 'firstMonthOnAccount'];
            var total = 0;
            var rent = Number(this.contractData.rent);
            for (var i in addKeys) {
                var key = addKeys[i];
                var amount = Number(parseInt(this.contractData[key]));
                if (key == 'deposit' && Number(this.contractData.depositMonths) > 0) {
                    amount = Number(this.contractData.depositMonths) * rent;
                } else if (key == 'prepaidRent' && Number(this.contractData.prepaidMonths) > 0) {
                    amount = Number(this.contractData.prepaidMonths) * rent;
                }
                if (amount > 0) {
                    total += amount;
                }
            }
            total += this.firstMonthFees;
            return total;
        }
    },
    mounted() {
        this.tabStep(0);
        var self = this;
        setInterval(function () {
            self.markBulletsAsCompleted();
        }, 500);


        this.houseRulesUploadOptions = {
            thumbnailWidth: 150,
            maxFilesize: 10,
            paramName: 'filename',
            headers: {
                'Authorization': 'Bearer ' + this.getToken
            },
            autoProcessQueue: true,
            dictDefaultMessage: this.$t('label.upload.placeholder'),
            uploadMultiple: false,
            url: window.config.apiUrl + 'api/draft-contract/' + this.$route.params.id + '/upload/house-rules',
            acceptedFiles: '.pdf'
        }

        this.energyRankUploadOptions = {
            thumbnailWidth: 150,
            maxFilesize: 10,
            paramName: 'filename',
            headers: {
                'Authorization': 'Bearer ' + this.getToken
            },
            autoProcessQueue: true,
            dictDefaultMessage: this.$t('label.upload.placeholder'),
            uploadMultiple: false,
            url: window.config.apiUrl + 'api/draft-contract/' + this.$route.params.id + '/upload/energy-rank',
            acceptedFiles: '.pdf'
        }

        this.customUploadDropzoneOptions = {
            url: window.config.apiUrl + 'api/draft-contract/' + this.$route.params.id + '/upload/custom',
            thumbnailWidth: 150,
            maxFilesize: 10,
            paramName: 'filename',
            headers: {
                'Authorization': 'Bearer ' + this.getToken
            },
            autoProcessQueue: true,
            addRemoveLinks: false,
            dictDefaultMessage: this.$t('label.upload.placeholder'),
            uploadMultiple: false,
            acceptedFiles: '.pdf'
        }

    },

    created() {
        this.$root.$on('close-contract-preview', () => {
            this.showPdfViewver = false;
        });

        var self = this;
        this.$root.$on('datetimechange', function (value) {
            if (value.id.indexOf('Supply_') >= 0) {
                self.contractData[value.id.replace('Supply_', '')] = value.value;
            } else {
                self.contractData[value.id] = value.value;
            }
        });

        this.$root.$on('specialConditionsLoaded', function () {
            self.specialConditionsLoaded = true;
        });

        this.loadCustomUploads();

        this.$store.dispatch('fetchSingleDraftContract', {
            id: this.$route.params.id,
            callback: (response) => {

                this.draftContract = response;

                if (response.contractData.inspectionBeforeMovingInDate) {
                    if (!self.isIE()) {
                        let date = new Date(response.contractData.inspectionBeforeMovingInDate);
                        response.contractData.inspectionBeforeMovingInDate = date.toISOString();
                    }
                }

                if (response.contractData.heatingOtherSource) {
                    self.heatingShowOther = true;
                }

                self.$store.dispatch('fetchSingleProperty', self.$store.getters.getSingleDraftContract.property.id);
                for (var key in self.contractData) {
                    if (['property', 'accessible'].indexOf(key) == -1) {
                        self.contractData[key] = self.$store.getters.getSingleDraftContract.contractData[key];
                    }
                }

                self.allowAutoSave = true;

                self.custom_special_conditions_enabled = response.custom_special_conditions_enabled;
                self.custom_special_conditions_text = response.custom_special_conditions_text;
                self.version = self.getSingleDraftContract.version;
                self.contractData.property = self.getSingleProperty;
                self.usingBehalfOfLandlord = self.getSingleDraftContract.behalfOfLandlord.usingBehalfOfLandlord;
                self.behalfOfLandlordId = self.getSingleDraftContract.behalfOfLandlord.landlordId;
                self.behalfOfLandlordMustApprove = self.getSingleDraftContract.behalfOfLandlord.landlordMustApprove;
                self.behalfOfLandlordEmail = self.getSingleDraftContract.behalfOfLandlord.email;
                self.behalfOfLandlordSentForApproval = self.getSingleDraftContract.behalfOfLandlord.sentForApproval;
                self.behalfOfLandlordApproved = self.getSingleDraftContract.behalfOfLandlord.approvedOn;
                self.approvalRevokeable = self.getSingleDraftContract.behalfOfLandlord.revokeable;
                self.approvedByLandlord = self.getSingleDraftContract.behalfOfLandlord.approvedByLandlord;
                self.isAwaitingLandlordApproval = self.getSingleDraftContract.behalfOfLandlord.isAwaitingLandlordApproval;
                self.isReadyForSignature = self.getSingleDraftContract.behalfOfLandlord.isReadyForSignature;

                // fix vue-numeric null conflicts
                if (self.contractData.rent === null) {
                    self.contractData.rent = 0;
                }

                if (self.contractData.area === null) {
                    self.contractData.area = 0;
                }

                if (self.contractData.areaForBusiness === null) {
                    self.contractData.areaForBusiness = 0;
                }
            }
        }).finally(() => {
            this.showLoader = false;
        });

        window.addEventListener('hashchange', () => {
            if (location.hash) {

                this.tabStep(0)
            }
        });

        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    watch: {
        contractData: {
            handler: function (contractData, oldVal) {
                this.updateAutoCalculations();
                this.validateMonthlyPayDate();
            },
            deep: true
        }
    },
    methods: {
        /**
         * Sync predefined special conditions with current contract data state formed by clicking on
         * checkboxes or radio buttons.
         * @see https://app.clickup.com/t/50j6h7
         * @see https://app.clickup.com/t/a0why3
         */
        pushSpecialConditions() {

            console.debug('DigitalContractWizard.vue::pushSpecialConditions');

            if (!this.$refs.specialConditionsEditor) {
                return;
            }

            /**
             * Wizard step: Ønskes standard huslejeregulering / Standard house rental regulation
             * Selection: Yes
             * §11 Label: Huslejeregulering
             * ID: 1
             */
            this.$refs.specialConditionsEditor.syncSpecialCondition(1, this.contractData.standardRentRegulation === true);

            /**
             * Wizard step: Smoking
             * Selection: No
             * §11 Label: Røgfri beboelse
             * ID: 2
             */
            this.$refs.specialConditionsEditor.syncSpecialCondition(2, this.contractData.smokingAllowed === false);

            /**
             * Wizard step: Tillad elektronisk kommunikation mellem lejer og udlejer / Allow electronic communication between tenant and landlord
             * Selection: Yes
             * §11 Label: Elektronisk kommunikation
             * ID: 4
             */
            this.$refs.specialConditionsEditor.syncSpecialCondition(4, this.contractData.allowElectronicCommunication === true);

            /**
             * Wizard step: Tidsbegrænset lejemål
             * Selection: Yes
             * §11 Label: Tidsbegrænset leje
             * Special note: Copy the date value specified and insert it into the text
             * ID: 13
             */
            this.$refs.specialConditionsEditor.syncSpecialCondition(13, this.contractData.limitedRenting === true);

            if (this.contractData.rentalExpires !== '') {
                this.$refs.specialConditionsEditor.insertSpecialConditionDate(13, this.contractData.rentalExpires);
            }

            /**
             * Wizard step: Varme
             * Selection: Yes - on Option 3
             * §11 Label: Varmeværkstilmelding
             * Special note: The selection made in the checkboxes makes no difference
             * ID: 21
             */
            this.$refs.specialConditionsEditor.syncSpecialCondition(21, this.contractData.heatingAccountingMode === 'third_party');

            /**
             * Wizard step: El
             * Selection: Yes - on Option 3
             * §11 Label: Elværkstilmelding
             * ID: 23
             */
            this.$refs.specialConditionsEditor.syncSpecialCondition(23, this.contractData.electricityAccountingMode === 'third_party');

            /**
             * Wizard step: Vand
             * Selection: Yes - on Option 3
             * §11 Label: Tilmelding til vandværk
             * Special note: The selection made in the checkboxes makes no difference
             * ID: 24
             */

            this.$refs.specialConditionsEditor.syncSpecialCondition(24, this.contractData.waterAccountingMode === 'third_party');

            /**
             * Wizard step: TV
             * Selection: Yes
             * §11 Label: Ændringer i TV-pakke
             * ID: 25
             */
            this.$refs.specialConditionsEditor.syncSpecialCondition(25, this.contractData.signalSupplyBy === 'onaccount');

            /**
             * Wizard step: Internet
             * Selection: Yes
             * §11 Label: Ændringer i internetabonnement
             * ID: 26
             */
            this.$refs.specialConditionsEditor.syncSpecialCondition(26, this.contractData.landlordSuppliesInternetAccess === true);

            /**
             * Wizard step: Angiv om der skal være indflytningssyn
             * Selection: Yes - on checkbox
             * §11 Label: 28
             * Special note: If no date is provided it automatically adds a text to the contract hardcoded on the Backend side
             */

            this.$refs.specialConditionsEditor.syncSpecialCondition(28, this.contractData.inspectionBeforeMovingIn === true
                && this.contractData.inspectionBeforeMovingInDate !== '');

            if (this.contractData.inspectionBeforeMovingInDate !== '') {
                this.$refs.specialConditionsEditor.insertSpecialConditionDate(28, this.contractData.inspectionBeforeMovingInDate);
            }

            /**
             * Wizard step: Husorden / House rules
             * Selection: Yes
             * §11 Label: Husorden
             * ID: 40
             */
            this.$refs.specialConditionsEditor.syncSpecialCondition(40, this.contractData.houseRulesIssued === true);

            /**
             * Wizard step: Er husdyr tilladt?
             * Selection: Yes - on Option 2
             * §11 Label: Specialtilladelse til husdyr
             * ID: 42
             */
            this.$refs.specialConditionsEditor.syncSpecialCondition(42, this.contractData.petsAllowed === 1);

            /**
             * Wizard step: Er husdyr tilladt?
             * Selection: Yes - on Option 1
             * §11 Label: Totalforbud mod husdyr
             * ID: 43
             */
            this.$refs.specialConditionsEditor.syncSpecialCondition(43, this.contractData.petsAllowed === 0);

            this.save();
        },
        specialConditionEnabledCallback(id) {
            console.debug('DigitalContractWizard.vue::specialConditionEnabledCallback', id);

            switch (id) {
                case 1:
                    this.contractData.standardRentRegulation = true;
                    break;
                case 2:
                    this.contractData.smokingAllowed = false;
                    break;
                case 4:
                    this.contractData.allowElectronicCommunication = true;
                    break;
                case 13:
                    this.contractData.limitedRenting = true;
                    break;
                case 21:
                    this.contractData.heatingAccountingMode = 'third_party';
                    break;
                case 23:
                    this.contractData.electricityAccountingMode = 'third_party';
                    break;
                case 24:
                    this.contractData.waterAccountingMode = 'third_party';
                    break;
                case 25:
                    this.contractData.sharedSignalSupply = true;
                    this.contractData.signalSupplyBy = 'onaccount';
                    break;
                case 26:
                    this.contractData.landlordSuppliesInternetAccess = true;
                    break;
                case 28:
                    this.contractData.inspectionBeforeMovingIn = true;
                    break;
                case 40:
                    this.contractData.houseRulesIssued = true;
                    break;
                case 42:
                    this.contractData.petsAllowed = 1;
                    break;
                case 43:
                    this.contractData.petsAllowed = 0;
                    break;
            }
        },
        specialConditionDisabledCallback(id) {
            console.debug('DigitalContractWizard.vue::specialConditionDisabledCallback', id);

            switch (id) {
                case 1:
                    this.contractData.standardRentRegulation = false;
                    break;
                case 2:
                    this.contractData.smokingAllowed = null;
                    break;
                case 4:
                    this.contractData.allowElectronicCommunication = false
                    break;
                case 13:
                    this.contractData.limitedRenting = false;
                    this.contractData.rentalExpires = '';
                    break;
                case 21:
                    this.contractData.heatingAccountingMode = null;
                    break;
                case 23:
                    this.contractData.electricityAccountingMode = null;
                    break;
                case 24:
                    this.contractData.waterAccountingMode = null;
                    break;
                case 25:
                    this.contractData.sharedSignalSupply = false
                    this.contractData.signalSupplyBy = null;
                    break;
                case 26:
                    this.contractData.landlordSuppliesInternetAccess = false;
                    break;
                case 28:
                    this.contractData.inspectionBeforeMovingIn = false;
                    this.contractData.inspectionBeforeMovingInDate = '';
                    break;
                case 40:
                    this.contractData.houseRulesIssued = false;
                    break;
                case 42:
                    this.contractData.petsAllowed = null;
                    break;
                case 43:
                    this.contractData.petsAllowed = null;
                    break;
            }
        },
        tenantTabNextCallback(tenants) {
            this.contractData.tenants = tenants;
            this.tabStep(1);
        },
        toggleOverviewNav: function () {
            this.openOverviewNav = !this.openOverviewNav

        },
        toggleTopNav: function () {
            this.openTopNav = !this.openTopNav;

        },
        tabClicked: function (selectedTab) {
            this.tabTitle = selectedTab.tab.name;
            this.openTopNav = false;

        },
        validateMonthlyPayDate() {
            if (this.contractData.monthlyPayDate) {
                this.contractData.monthlyPayDate = String(this.contractData.monthlyPayDate).replace(/[^0-9]+/g, '');
                if (Number(this.contractData.monthlyPayDate) > 31) {
                    this.contractData.monthlyPayDate = 28;
                }
            }
        },
        closePdfViewer() {
            this.pdfPreviewUrl = '';
            this.showPdfViewver = false;
        },
        isIE() {
            return navigator.userAgent.indexOf("MSIE") != -1 || (!!document.documentMode == true);
        },
        deleteCustomUpload(fileId) {
            if (!confirm(this.$t('digital-contract.delete-custom-upload.confirm'))) {
                return;
            }
            axios({
                method: 'DELETE',
                cancelToken: window.AuthorizationCancelSource.token,
                url: window.config.apiUrl + 'api/draft-contract/' + this.$route.params.id + '/custom-upload/' + fileId
            }).then(response => {
                this.loadCustomUploads();
            })
        },
        updateCustomUploadName(fileId) {
            var fileName;
            for (var i in this.customUploads) {
                if (this.customUploads[i].id == fileId) {
                    fileName = this.customUploads[i].name;
                }
            }
            if (!fileName) {
                this.$swal('Filename cannot be empty', [], 'error');
                return;
            }
            axios({
                method: 'PATCH',
                cancelToken: window.AuthorizationCancelSource.token,
                url: window.config.apiUrl + 'api/draft-contract/' + this.$route.params.id + '/custom-upload/' + fileId,
                data: {
                    name: fileName
                }
            })
        },
        loadCustomUploads() {
            axios({
                method: 'GET',
                cancelToken: window.AuthorizationCancelSource.token,
                url: window.config.apiUrl + 'api/draft-contract/' + this.$route.params.id + '/custom-uploads',
            }).then(response => {
                this.customUploads = response.data;
            })
        },
        customUploadSuccess() {
            this.$store.commit('setSuccessBarMessage', this.$t('digital-contract.upload-completed.label'));
            this.loadCustomUploads();
        },
        customUploadError(data) {

            if (data.xhr !== null && (data.xhr.status === 401 || data.xhr.status === 403)) {
                this.$store.commit('setToken', null)
                return;
            }

            if (typeof data.xhr == 'undefined') {
                this.$swal(this.$t('general.unknown-error.label'), [], 'error');

                return;
            }
            let response = JSON.parse(data.xhr.responseText);

            this.$swal(this.$t(response.message), [], 'error');
        },
        updateAutoCalculations() {
            this.calculateFirstMonthOnAccount();
            this.calculateFirstMonthRent();
        },
        changeSupplyAccountingMode(supply) {
            this.contractData[supply + 'Source'] = [];
            if (typeof this.contractData[supply + 'OtherSource'] != 'undefined') {
                this.contractData[supply + 'OtherSource'] = '';
                this[supply + 'ShowOther'] = false;
            }

            if (this.contractData.onAccount != undefined && this.contractData.onAccount[supply] != undefined) {
                this.contractData.onAccount[supply] = 0;
            }

            this.pushSpecialConditions();
        },
        calculateForPeriod(fullValue) {
            if (!this.contractData.occupancyDate) {
                return;
            }
            let isQuarterly = this.contractData.paymentMonthlyOrThirdMonth == 2 ? true : false;
            let occupancyDate = new Date(this.contractData.occupancyDate);
            let lastDay = this.lastDayOfOccupationMonth.getDate();
            let currentDay = occupancyDate.getDate();

            if (!lastDay) {
                return 0;
            }

            let dailyValue = fullValue / lastDay;
            // We add +1 to include the actual day tenant moves in
            let total = dailyValue * (lastDay - currentDay + 1);

            if (currentDay == 1) {
                total = fullValue;
            }

            if (isQuarterly) {
                let diffInMonths = 2 - occupancyDate.getMonth() % 3;
                total += Math.round(diffInMonths * fullValue);
            }

            return Math.round(total);
        },
        calculateFirstMonthOnAccount() {
            this.contractData.firstMonthOnAccount = this.calculateForPeriod(this.onAccountSum());
        },
        calculateFirstMonthRent() {
            this.contractData.firstMonthRent = this.calculateForPeriod(this.contractData.rent);
        },
        dateFormat(date) {
            return date ? moment(String(date)).format('DD-MM-YYYY') : '';
        },
        onAccountSum() {
            let total = 0;
            let nativeOnAccount = ['heating', 'water', 'electricity', 'cooling', 'internet', 'antenna', 'representation'];
            for (var i in nativeOnAccount) {
                var value = Number(this.contractData.onAccount[nativeOnAccount[i]]);
                if (value > 0 && !isNaN(value)) {
                    total += value;
                }
            }
            for (var i in this.contractData.extraOnAccount) {
                var value = Number(this.contractData.extraOnAccount[i].value);
                if (value > 0 && !isNaN(value)) {
                    total += value;
                }
            }
            return total;
        },
        deleteExtraAmenity(id) {
            let fees = this.contractData.extraAmenities;
            let result = [];
            for (var i in fees) {
                if (i != id) {
                    result.push(fees[i]);
                }
            }
            this.contractData.extraAmenities = result;
        },
        deleteFirstMontFee(id) {
            let fees = this.contractData.firstMonthFees;
            let result = [];
            for (var i in fees) {
                if (i != id) {
                    result.push(fees[i]);
                }
            }
            this.contractData.firstMonthFees = result;
        },
        mustBeSet(keys, target) {
            if (typeof target == 'undefined') {
                target = this.contractData;
            }
            for (var i in keys) {
                var key = keys[i];
                if (target[key] == undefined || target[key] === '' || target[key] == null) {
                    return false;
                }
            }
            return true;
        },
        tabCompletedGeneral() {
            return this.mustBeSet([
                'rent',
                'paymentMonthlyOrThirdMonth',
                'occupancyDate',
                'rentalType',
                'numberOfRooms',
                'area'
            ]);
        },
        tabCompletedSupply() {
            return this.mustBeSet([
                'heatingAccountingMode',
                'coolingAccountingMode',
                'waterAccountingMode',
                'electricityAccountingMode'
            ]);
        },
        tabCompletedMonthlyPayments() {
            return this.mustBeSet([
                'onAccountTaxationDate'
            ]);
        },
        tabCompletedDeposit() {
            return this.mustBeSet([
                'depositMonths',
                'prepaidMonths',
                // 'depositPaymentDate',
                'firstRentPaymentDate'
            ]);
        },
        tabCompletedAccess() {
            for (var i in this.contractData.access) {
                if (this.contractData.access[i].checked) {
                    return true;
                }
            }
            for (var i in this.contractData.amenities) {
                if (this.contractData.amenities[i].checked) {
                    return true;
                }
            }
            if (this.contractData.extraAccess.length > 0) {
                return true;
            }
            if (this.contractData.limitedTenantChildren) {
                return true;
            }
            return false;
        },
        tabCompletedMaintenance() {
            return this.mustBeSet([
                'maintenanceBy',
                'maintenanceOutdoorBy'
            ]);
        },
        tabCompletedOther() {
            return this.mustBeSet([
                'petsAllowed',
                'houseRules',
                'smokingAllowed'
            ]);
        },
        tabCompletedSpecialConditions() {
            return this.contractData.specialConditions.length
                || (this.version > 1 && this.contractData.special_conditions_mode === 2);
        },
        tabCompletedLandlord() {

            if (this.usingBehalfOfLandlord === true
                && this.getLandlordData.type === 'private'
                && this.getLandlordData.email !== ''
            ) {
                return true;
            }

            if ((this.usingBehalfOfLandlord === false || this.getLandlordData.type === 'commercial')
                && this.getLandlordData.name !== ''
                && this.getLandlordData.email !== ''
                && this.getLandlordData.zipCode !== ''
                && this.getLandlordData.city !== ''
                && this.getLandlordData.address !== ''
                && this.getLandlordData.bankName !== ''
                && this.getLandlordData.bankRegNo !== ''
                && this.getLandlordData.bankAccountNo !== ''
            ) {
                return true;
            }

            return false;
        },
        tabCompletedTenant() {
            return this.contractData.tenants !== null && this.contractData.tenants.length > 0;
        },
        tabIsCompleted(tabName) {
            switch (tabName) {
                case 'tab-general':
                    return this.tabCompletedGeneral();
                case 'tab-supply':
                    return this.tabCompletedSupply();
                case 'tab-monthly-payments':
                    return this.tabCompletedMonthlyPayments();
                case 'tab-deposit':
                    return this.tabCompletedDeposit();
                case 'tab-access':
                    return this.tabCompletedAccess();
                case 'tab-maintenance':
                    return this.tabCompletedMaintenance();
                case 'tab-other':
                    return this.tabCompletedOther();
                case 'tab-special-conditions':
                    return this.tabCompletedSpecialConditions();
                case 'tab-landlord':
                    return this.tabCompletedLandlord();
                case 'tab-tenant':
                    return this.tabCompletedTenant();
            }
            return false;
        },
        markBulletsAsCompleted() {
            var self = this;
            if (!this.$refs.tabList) {
                return;
            }
            let someCollection = document.querySelectorAll('.tabs-component-tabs li')
            Array.from(someCollection).forEach(function (item) {
                var useFill = self.tabIsCompleted(item.firstChild.href.replace(/^.*?#([a-z\-\_0-9]+)$/, '$1'));
                if (useFill) {
                    if (item.className.indexOf('is-filled') == -1) {
                        item.className = item.className + ' is-filled';
                    }
                } else {
                    item.className = item.className.replace('is-filled', '').replace('  ', ' ');
                }
            })
        },
        fetchDraftContract() {
            axios({
                method: 'GET',

                url: window.config.apiUrl + 'api/draft-contract/' + this.$route.params.id,
            }).then(response => {
                this.$store.dispatch('fetchSingleProperty', repsonse.data.contractData.property.id);
            })
        },
        displaySupplyGroup(supply, accountingMode) {
            if (supply == 'heating' || accountingMode == 'onaccount') {
                return true;
            }
            return false;
        },
        deleteUpload(type) {
            var self = this;
            axios({
                method: 'DELETE',
                url: window.config.apiUrl + 'api/draft-contract/' + this.$route.params.id + '/upload/' + type,

            }).then(response => {
                let parsedType = type == 'house-rules' ? 'houseRulesPdf' : 'energyRankPdf';
                self.contractData[parsedType] = '';
            })
        },
        houseRulesUploadSuccess(file, response) {
            this.contractData.houseRulesPdf = response;
        },
        energyRankUploadSuccess(file, response) {
            this.contractData.energyRankPdf = response;
            this.pushSpecialConditions();
        },
        updateTaxationDate() {
            this.calculateFirstMonthRent();
        },
        getBehalfOfLandlordData() {

            return {
                using: this.usingBehalfOfLandlord,
                approvalByLandlord: this.behalfOfLandlordMustApprove,
            };
        },

        tabStep(c) {
            window.scrollTo(0, 0);
            for (var i in this.$children) {
                var child = this.$children[i];
                if (child.$el.id == 'contract-tabs') {
                    var idx = child.getActiveTabIndex();
                    var hash = child.getTabHash(idx + c);
                    child.selectTab(hash);

                    this.currentStep = child.getActiveTabIndex() + 1; //current step in topnav (mobile)

                    var lastStep = ((c == 1 || !c) && !child.getTabHash(child.getActiveTabIndex() + 1));
                    var firstStep = ((c == 1 || !c) && !child.getTabHash(child.getActiveTabIndex() - 1));

                    if (lastStep) {
                        this.showNextStep = false;
                    } else {
                        this.showNextStep = true;
                    }

                    if (firstStep) {
                        this.showPrevStep = false;
                    } else {
                        this.showPrevStep = true;
                    }
                }
            }

            if (this.allowAutoSave) {
                this.save();
            }
        },
        deleteExtraAccess(index) {
            var list = this.contractData.extraAccess;
            var result = [];
            for (var i in list) {
                if (i != index) {
                    result.push(list[i]);
                }
            }
            this.contractData.extraAccess = result;
        },
        deleteExtraOnAccount(index) {
            var list = this.contractData.extraOnAccount;
            var result = [];
            for (var i in list) {
                if (i != index) {
                    result.push(list[i]);
                }
            }
            this.contractData.extraOnAccount = result;
        },
        addOnAccount() {
            var c = this.contractData.extraOnAccount.length;
            this.$set(this.contractData.extraOnAccount, c, {
                'name': ''
            });

        },
        addAccess() {
            var c = this.contractData.extraAccess.length;
            this.$set(this.contractData.extraAccess, c, {
                'name': '',
                'numeration': ''
            });
        },
        addExtraAmenity() {
            var c = this.contractData.extraAmenities.length;
            this.$set(this.contractData.extraAmenities, c, {
                'name': ''
            });
        },
        revokeApproval() {
            var self = this;
            this.revokingApproval = true;
            axios({
                method: 'POST',
                cancelToken: window.AuthorizationCancelSource.token,
                url: window.config.apiUrl + 'api/draft-contract/' + this.$route.params.id + '/revoke-approval',

            }).then(response => {
                this.revokingApproval = false;
                this.approvalRevokeable = false;
                this.$store.commit('setSuccessBarMessage', this.$t('digital-contract.approval-revoked.label'));
                this.isReadyForSignature = false;
                this.isAwaitingLandlordApproval = false;
                this.approvedByLandlord = false;
            }).finally(e => {
                this.revokingApproval = false;
            });
        },
        addFirstMonthFee() {
            var c = this.contractData.firstMonthFees.length;
            this.$set(this.contractData.firstMonthFees, c, {
                'name': '',
                'value': 0
            });
        },
        landlordInfoFilled() {
            for (var key of ['name', 'address', 'zipCode', 'city', 'email']) {
                if (!this.getLandlordData[key]) {
                    return false;
                }
            }
            return true;
        },
        sendEmail() {
            if (!this.landlordInfoFilled()) {
                this.$swal(this.$t('digital.sent.landlord-not-filled.error'), [], 'error');
                return;
            }

            if (!this.isReadyForSignature && this.contractData.usingBehalfOfLandlord) {
                this.$swal(this.$t('digital.sent.landlord-must-approve.error'), [], 'error');
                return;
            }
            this.sendingEmail = true;
            this.$router.push('/contracts/digital-contract/confirm/' + this.$route.params.id);
        },
        getContractId() {
            return store.getters.getSingleDraftContract.id;
        },
        getData() {
            this.contractData['landlordData'] = {
                name: this.draftContract.definition.landlord_name,
                address: this.draftContract.definition.landlord_address,
                zipCode: this.draftContract.definition.landlord_zipcode,
                city: this.draftContract.definition.landlord_city,
                email: this.draftContract.definition.landlord_email,
                cvr: this.draftContract.definition.landlord_vatno,
                type: this.draftContract.definition.landlord_type
            };

            return this.contractData;
        },
        save(callback) {
            console.debug('DigitaContractWizard:save');

            if(moment(this.contractData.occupancyDate).isBefore(moment().subtract(2,'days'), 'day')
                && this.contractData.electricityAccountingMode === 'third_party_simplex') {
                this.contractData.electricityAccountingMode = 'third_party';

                console.log('reset')
            }

            var saveData = this.getData();

            saveData['special_conditions_mode'] = this.contractData.special_conditions_mode;

            this.saveDraftButtonDisabled = true;
            axios({
                method: 'PATCH',
                url: window.config.apiUrl + 'api/draft-contract/' + this.getContractId(),
                cancelToken: window.AuthorizationCancelSource.token,
                data: {
                    contract_data: saveData,
                    behalfOfLandlord: this.getBehalfOfLandlordData()
                }
            }).then(response => {
                this.saveDraftButtonDisabled = false;
                this.$store.commit('setSuccessBarMessage', this.$t('digital.messages.contract-saved'));
                if (typeof callback == 'function') {
                    callback();
                }

                this.$refs.tenantTab.save();
            })
        },
        sendForApproval() {
            var self = this;
            var landlordEmail = this.behalfOfLandlordEmail;
            this.sendingForApproval = true;

            if (!landlordEmail) {
                this.behalfOfLandlordEmail = this.getLandlordData.email;
                landlordEmail = this.behalfOfLandlordEmail;
            }

            if (!landlordEmail && this.behalfOfLandlordMustApprove) {
                this.$swal(this.$t('digital.review.landlord-email-unknown.error'), [], 'error');
                return;
            }

            axios({
                method: 'POST',
                url: window.config.apiUrl + 'api/draft-contract/' + this.$route.params.id + '/send-for-approval',
                cancelToken: window.AuthorizationCancelSource.token,
                data: {
                    email: landlordEmail
                }
            }).then(response => {
                this.approvalRevokeable = true;
                this.$store.commit('setSuccessBarMessage', this.$t('digital-contract.approval-sent.label'));

                if (this.behalfOfLandlordMustApprove) {
                    this.isAwaitingLandlordApproval = true;
                }

                this.goToStatusPage();
            }).finally(e => {
                self.sendingForApproval = false;
            });
        },
        goToStatusPage() {
            this.$router.push('/contracts/digital-contract/status/' + this.$route.params.id);
        },
        createPdf() {
            var self = this;

            this.generatingPdf = true;
            this.save(() => {

                axios({
                    method: 'POST',
                    url: window.config.apiUrl + 'api/contract/' + this.getContractId(),
                    cancelToken: window.AuthorizationCancelSource.token,
                    data: {
                        exportUrl: true,
                        contract_data: this.getData(),
                        behalfOfLandlord: this.getBehalfOfLandlordData()
                    }
                }).then(function (response) {
                    let url = response.data.exportUrl;
                    self.pdfPreviewUrl = url + (url.indexOf('?') == -1 ? '?' : '&') + 'token=' + self.getToken + '&r=' + Math.random();
                    self.showPdfViewver = true;
                    self.$refs.pdfViewer.reload();
                }).finally(e => {
                    self.generatingPdf = false;
                });

            });

        },
        supplyDetails: function() {
            this.showSupplyDetails = !this.showSupplyDetails;
        },
        setModeValue: function () {
            this.contractData.electricityAccountingMode = 'third_party_simplex';
            this.electricityRadios = 'third';
            this.save();
        },
        setOnAccountValue: function () {
            this.electricityRadios = 'first';
        }
    }
}

</script>
<style lang="scss" scoped>

.status-box {
    padding-top: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #efefef;
}

.status-box:last-child {
    border-bottom: none;
    padding-bottom: 0px;
}

.status-box-row {
    display: flex;
}

.status-box strong {
    display: block;
    margin-bottom: 6px;
}

.dot {
    margin-right: 10px;
    width: 15px;
    height: 15px;
    background: #ccc;
    border-radius: 50%;
}

.dot.green {
    background: green;
}

.dot.orange {
    background: orange;
}

.is-filled::before {
    background: green !important;
}

[readonly] {
    background: #efefef;
    opacity: 0.8;
    outline: none;
    border-color: #aaa;
    cursor: not-allowed;
}

.vdatetime-popup__header {
    background-color: #7129e9;
}

.vdatetime-popup__body {
    min-height: 345px;
}

.vdatetime-calendar__month__day--selected > span > span,
.vdatetime-calendar__month__day--selected:hover > span > span {
    background-color: #7129e9;
}

.moving-in-report-date {
    & > .date-input.input-inner {
        width: 90%;
    }

    & > .calendar-delete {
        cursor: pointer;
        width: 10%;
        right: 0px;
        position: absolute;
        top: 51px;

        & > svg > path.fill-color {
            fill: #e8194e;
        }
    }
}

.opacity-5 {
    opacity: 0.5;
}
</style>
